import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ProblemToken } from '../shared/problem-token';
import { ProblemDetails, ProblemCause, ProposedAction, ProblemAction, ProblemComment } from '../shared/problem-details'
import { Deparment, RespPerson, RootCauseCategory, Customer, Product, PolePart, Def, InspectionDoneBy, Plan, DailyProdHighlights, DPHToken, MaterialShortage,
         MSCToken, DailyDeliveryPlan, DSPToken, Type, CustomerInspectionPlan, CIPToken, GreenStickerPlan, GSPToken, 
         InprocessQualityIssues, IQIToken, CCRPSMToken, CCRPStatusMonitoring,ProductionStatusMonitoring,
         PSMToken,ManPowerAllocation,WorkCategory,TaskList,PoleStockReview,PSRToken,TaskAllocation,TaskLinked,TaskDayToken, 
         addUser, Employee, Legends, DPHDayToken, FooterData, MSCDayToken, DSPDayToken, CIPDayToken,PSRDayToken, subProduct, ProductsList, GSPDayToken, uModule, uModParameter, IQIDayToken, CCRPDayToken, PSMDayToken, NWCMPointData, NWCMStatusMonthData, NWCMHistoryToken, e_KpiImage, FinishedGoodsDaily, FinishedGoodsToken, MaterialToken, GenResponse, itsQIssue
} 
         from '../shared/misc-classes';
import { GenService } from 'app/shared/gen-ser.service';
import { ManPowAllocComponent } from 'app/daily-act/man-pow-alloc/man-pow-alloc.component';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class DataService{
    private static getProblemsForDateRange:string = '/getproblemsdaterange';
    private static getProblemsForDay:string = '/getproblemsforday';
    private static getDataDefs:string = '/getdatadefinitions';
    private static getPlan:string = '/getPlan';
    private static getDailyProdHighlight:string = '/getdailyprodhigh';
    private static getMaterialShortage:string = '/getmaterialshortage';
    private static getDailyDeliveryPlan:string = '/getdailydelivryplan';
    private static getCustomerInspectionPlan:string = '/getcustomerinspectionplan';
    private static getGreenStickerPlan:string = '/getgreenstickerplan';
    //private static getInprocessQualityIssue:string = '/getinprocessqualityissues';
    private static getInprocessQualityIssue_1:string = '/getinprocessqualityissues';
    private static getCCRPStatusMonitoring:string = '/getccrpstatusmonitoring';
    private static getCCRPAllData:string = '/getCCRPAllData';
    private static getProdStatusMonitoring:string = '/getprodstatusmonitoring';
    private static getPoleStockRevw:string = '/getPoleStockReview';
    private static getManPowerAllocation:string = '/getManPowerAllocation';
    private static getEmployeeList:string = '/getEmployeeList';
    private static getUserAccessLevel:string = '/getuseraccesslevel';
    private static getNwcmTreeStatus:string = '/getnwcmtree';
    private static getFooterData:string = '/getFooterData';
    private static getMaterialShortageData:string = '/getmatshortdata';
    private static getCopyProdStatusMonitoring:string = '/getCopyProdStatusMonitoring';
    private static getCopyPoleStkRevw:string = '/getCopyPoleStkRevw';
    private static getCopyMaterialShortage:string = 'getCopyMaterialShortage';
    private static getCopyCCRPStatusMonitoring:string = '/getCopyCCRPStatusMonitoring';
    private static getQualityGembaCard:string = '/getQualityGembaCard';
    private static getMaterialGembaCard:string = '/getMaterialGembaCard';

    private static saveBSProblem:string = '/savebsproblem';
    private static savePlanApi:string = '/saveplan';
    private static saveDailyProdHighApi:string = '/savedlyprodhigh';
    private static saveMaterialShortageApi:string = '/savematerialshortage';
    private static saveDailyDeliveryPlanApi:string = '/savedailydeliveryplan';
    private static saveCustmrInspecPlanApi:string = '/savecustmrinspplan';
    private static saveGreenStickerPlanApi:string = '/savegreenstickerplan';
    private static saveInprocessQualityIssuesApi:string = '/saveinprocessqualityissues';
   // private static saveInprocessQualityIssuesApi:string = '/saveinprocessqualityissues_1';
    private static saveCCRPStatusApi:string = '/saveccrpstatusmonitoring';
    private static saveProdStatusApi:string = '/saveprodstatusmonitoring';
    private static savePoleStockApi:string = '/savepolestockreview';
    private static saveManPowerApi:string = '/savemanpowerallocation';
    private static saveGembaCardApi:string = '/savegembacarddata';
    private static saveNWCMTreeStatusApi:string = '/savenwcmtreestatus';
    private static saveSeverity:string = '/saveseverity';
    private static getGembaCardApi:string = '/getgembacarddata';
    private static getKpiImage = '/getkpiimage';
    private static sendGembaMoM = '/sendgembamom';
    private static getEmailGroups = '/getemailgroups';
    private static getEmailGroupMapping = '/getemailgroupmapping';
    private static getFinishedGoodsMonthly = '/getfgmonthlydata';
    private static saveFinishedGoodsMonthly = '/savefgmonthlydata';
    private static downloadFile = '/downloadfile';
    private static getInprocessQualityImportDataApi:string = '/getinprocimportdata';
    private static discardInprocessExportRecordsApi:string = '/discardincprocimportrecords';

    // Api Response msg   
    public static saveSuccessMsg = 'Data Saved.';
    public static saveErrorMsg = 'Failed to Save.';
    public static statusFail = 'FAIL';
    public static statusSuccess = 'OK';
    public static staleDateErrorMsg = 'The Data has been updated while you were editing, Please reload and make your changes again.';

    public static successCode = '000';
    public static failCode = '000'; 
    public static staleDataCode = '012';

    public itsToGembaLineIdMapping:any = { };
    public itsToGembaProductIdMapping:any= { };
    public itsToGembaStationIds = { };


    private _departmentList:Array<Deparment>;
    private _departmentListActive:Array<Deparment>;
    private _respPersonList:Array<RespPerson>;
    private _respPersonListActive:Array<RespPerson>;
    private _ohbRespPersonList:Array<RespPerson>;
    private _ohbRespPersonListActive:Array<RespPerson>;
    private _customerList:Array<Customer>;
    private _customerListActive:Array<Customer>;
    private _productList:Array<ProductsList>;
    private _productActiveList:Array<ProductsList>;
    private _productListMA:Array<Product>;
    private _productListMAActive:Array<Product>;
    private _productType:Array<Product>;
    private _productTypeActive:Array<Product>;
    private _mainProduct:Array<Product>;
    private _mainProductActive:Array<Product>;
    private _subProduct:Array<subProduct>;
    private _subProductActive:Array<subProduct>;
    private _inspectionDoneBy:Array<InspectionDoneBy>;
    private _inspectionDoneByActive:Array<InspectionDoneBy>;
    private _polePartList:Array<PolePart>;
    private _polePartListActive:Array<PolePart>;
    private _manPowerAllocation:ManPowerAllocation;
    private _manPowerAllocationActive:ManPowerAllocation;
    private _employeeList:Array<Employee>;
    private _employeeListActive:Array<Employee>;
    private _typeReady:Array<Type>=[];
    private _shortage:Array<Type>=[];
    private _formStatus:Array<Type>=[];
    private _shrtgeFormStatus:Array<Type>=[];
    private _ccrpReason:Array<Type>=[];
    private _ccrpStatus:Array<Type>=[];
    private _dispStatus:Array<Type>=[];
    private _typeAvailable:Array<Type>=[];
    private _typeStructure:Array<Type>=[];
    private _issueRelatedTo:Array<Def>=[];
    private _issueRelatedActive:Array<Def>=[];
    private _ncrCapturing:Array<Def>=[];
    private _ncrCapturingActive:Array<Def>=[];
    private _issueCapturing:Array<Def>=[];
    private _issueCapturingActive:Array<Def>=[];
    private _depositionDecision:Array<Def>=[];
    private _depositionDecisionActive:Array<Def>=[];
    private _statusActive:Array<Def>=[];
    private _status:Array<Def>=[];
    private _supplierName:Array<Def>=[];
    private _supplierNameActive:Array<Def>=[];
    private _defectSubCategory1:Array<Def>=[];
    private _defectSubCategory1Active:Array<Def>=[];
    private _defectSubCategory2:Array<Def>=[];
    private _defectSubCategory2Active:Array<Def>=[];
    private _defectSubCategory3:Array<Def>=[];
    private _defectSubCategory3Active:Array<Def>=[];
    private _defectCategory:Array<Def>=[];
    private _defectCategoryActive:Array<Def>=[];
    private _rootCauseCategories:Array<RootCauseCategory> = [];
    private _accessLevels:Array<uModule> = [];
    private _accessLevel:string = '';
    private _userName:string = '';
    private _userId:string = '';
    private _safetyLegend:Array<Legends>=[];
    private _materialLegend:Array<Legends>=[];
    private _qualityLegend:Array<Legends>=[];
    private _testingLegend:Array<Legends>=[];
    private _isDefLoaded:boolean = false;
    private _companyName:string = 'Loading...';
    public currPageName:string = "";
    private _e_KpiImage: e_KpiImage;
    public isInitialized:boolean = false;
    private initCounter:number = 0;
    public successOptions = {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 10
    };
    public failureOptions = {
        timeOut: 5000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 10
    };    
    
    public _currentSubMenuId:number = -1;
    
    constructor(private http:Http){
        this.getUserNameCookie();
        this.initRootCauseCategories();
        this.initLegends();
        this.initTypeDefs();
        this.initDataDefinitions();
        this.initUserAccessLevels();
        this.initMailgroupMapping();
    }
    //properties start
    get companyName():string{
        return this._companyName;
    }
    get userName():string{
        return this._userName;
    }
    get userId():string{
        return this._userId;
    }
    get rootCauseCatgories():Array<RootCauseCategory>{
        return this._rootCauseCategories;
    }
    get departments():Array<Deparment>{
        return this._departmentListActive;
    }
    get respPersons():Array<RespPerson>{
        return this._respPersonListActive;
    }
    get customers():Array<Customer>{
        return this._customerListActive;
    }
    get manPowerAllctn():ManPowerAllocation{
        return this._manPowerAllocationActive;
    }
    get products():Array<ProductsList>{
        return this._productActiveList;
    }
    get productList():Array<ProductsList>{
        return this._productList
    }
    get maproducts():Array<Product>{
        return this._productListMAActive;
    }
    get employeeList():Array<Employee>{
        return this._employeeListActive;
    }
    get producttype():Array<Product>{
        return this._productTypeActive;
    }
    get mainProduct():Array<Product>{
        return this._mainProductActive;
    }
    get subProduct():Array<subProduct>{
        return this._subProductActive;
    }
    get issueRelatedTo():Array<Def>{
        return this._issueRelatedActive
    }
    get ncrCapturing():Array<Def>{
        return this._ncrCapturingActive;
    }
    get issueCapturing():Array<Def>{
        return this._issueCapturingActive;
    }
    get status():Array<Def>{
        return this._statusActive;
    }
    get defectSubCategory1():Array<Def>{
        return this._defectSubCategory1Active
    }
    get defectSubCategory2():Array<Def>{
        return this._defectSubCategory2Active
    }
    get defectSubCategory3():Array<Def>{
        return this._defectSubCategory3Active
    }
    get defectCategory():Array<Def>{
        return this._defectCategoryActive;
    }
    get supplierName():Array<Def>{
        return this._supplierNameActive;
    }
    get depositionDecision():Array<Def>{
        return this._depositionDecisionActive;
    }
    get inspectionDoneBy():Array<InspectionDoneBy>{
        return this._inspectionDoneByActive;
    }
    get polePart():Array<PolePart>{
        return this._polePartListActive;
    }
    get shortage():Array<Type>{
        return this._shortage
    }
    get formStatus():Array<Type>{
        return this._formStatus;
    }
    get shrtgeFormStatus():Array<Type>{
        return this._shrtgeFormStatus;
    }
    get typeReady():Array<Type>{
        return this._typeReady;
    }
    get ccrpReason():Array<Type>{
        return this._ccrpReason;
    }
    get ccrpStatus():Array<Type>{
        return this._ccrpStatus;
    }
    get dispStatus():Array<Type>{
        return this._dispStatus;
    }
    get typeAvailable():Array<Type>{
        return this._typeAvailable;
    }
    get typeStructure():Array<Type>{
        return this._typeStructure;
    }
    // get poleDescPartNo():Array<Type>{
    //     return this._poleDescPartNo;
    // }
    get qualityLegend():Array<Legends>{
        return this._qualityLegend;
    }
    get safetyLegend():Array<Legends>{
        return this._safetyLegend;
    }
    get KpiImage(): e_KpiImage {
        return this._e_KpiImage;
    }
    //properties end
    //private functions start
    private getUserNameCookie(){
        var _tmpUserName = this.getCookie('username');
        if(_tmpUserName != ''){
            this._userName = decodeURI(_tmpUserName);
        }
        else{
            window.location.href = '/assets/login.html';   
        }
    }
    private getCookie(name: string) {
        let ca: Array<string> = document.cookie.split(';');
        let caLen: number = ca.length;
        let cookieName = `${name}=`;
        let c: string;

        for (let i: number = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) == 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }
    private initLegends(){
            this._safetyLegend.push(new Legends("Ok",0,"green",1));
            this._safetyLegend.push(new Legends("Near Misses/Unsafe Act",1,"blue",2));
            this._safetyLegend.push(new Legends("Incident",2,"red",3));
            this._safetyLegend.push(new Legends("Weekly Off/Holidays",3,"white",4));
            this._materialLegend.push(new Legends("Ok",0,"green",1));
            this._materialLegend.push(new Legends("Disturbances in Production",1,"blue",2));
            this._materialLegend.push(new Legends("Production Loss",2,"red",3));
            this._materialLegend.push(new Legends("Weekly Off/Holidays",3,"white",4));
            this._qualityLegend.push(new Legends("Ok",0,"green",1));
            this._qualityLegend.push(new Legends("Disturbances in Production",1,"blue",2));
            this._qualityLegend.push(new Legends("Production Loss",2,"red",3));
            this._qualityLegend.push(new Legends("Weekly Off/Holidays",3,"white",4));
            this._testingLegend.push(new Legends("Ok",0,"green",1));
            this._testingLegend.push(new Legends("Disturbances in Production",1,"blue",2));
            this._testingLegend.push(new Legends("Production Loss",2,"red",3));
            this._testingLegend.push(new Legends("Weekly Off/Holidays",3,"white",4));    
    }
    private initTypeDefs(){
        this._shortage.push(new Type("yes","Yes"));
        this._shortage.push(new Type("no","No"));
        this._formStatus.push(new Type("pending","Pending"));
        this._formStatus.push(new Type("completed","Completed"));
        this._shrtgeFormStatus.push(new Type("pending","Pending"));
        this._shrtgeFormStatus.push(new Type("resolved","Resolved"));
        this._typeReady.push(new Type("ready","Ready"));
        this._typeReady.push(new Type("not ready","Not Ready"));
        this._typeAvailable.push(new Type("available","Available"));
        this._typeAvailable.push(new Type("not available","Not Available"));
        this._typeStructure.push(new Type("available","Available"));
        this._typeStructure.push(new Type("not available","Not Available"));
        this._typeStructure.push(new Type("not applicable","Not Applicable"));
        this._ccrpReason.push(new Type("waiting for material","Waiting for Material"));
        this._ccrpReason.push(new Type("waiting for service engineer","Waiting for Service Engineer"));
        this._ccrpReason.push(new Type("waiting for closure from initiator","Waiting for Closure by Complaint Owner"));
        this._ccrpReason.push(new Type("other","Other Reasons"));
        this._ccrpStatus.push(new Type("in process","In Process"));
        this._ccrpStatus.push(new Type("closed","Closed"));
        this._dispStatus.push(new Type("dispatch","Dispatch"));
        this._dispStatus.push(new Type("not dispatch","Not Dispatch"))
    }
    private initRootCauseCategories(){
        this._rootCauseCategories = [];
        this._rootCauseCategories.push(new RootCauseCategory("man","Man",1,1));
        this._rootCauseCategories.push(new RootCauseCategory("material","Material",2,2));
        this._rootCauseCategories.push(new RootCauseCategory("method","Method",3,3));
        this._rootCauseCategories.push(new RootCauseCategory("machine","Machine",4,4));
        this._rootCauseCategories.push(new RootCauseCategory("environment","Environment",5,5));
    }
    private initDataDefinitions(){
        this.getDataDefinitions().subscribe((_result:boolean) => {
            this.initCounter++;
            if(this.initCounter >= 2){
                this.isInitialized = true;
            }
        });
    }
    private initUserAccessLevels(){
        this.getUserAccessLevels().subscribe((_result:boolean) => {
            this.initCounter++;
            if(this.initCounter >= 2){
                this.isInitialized = true;
            }
        });
    }
    private initMailgroupMapping(){
        //delay loading as not required immediately
        // setTimeout(() => {
        //     this.loadEmailGroups().subscribe((_result:boolean) => {});
        //     this.loadEmailGroupMapping().subscribe((_result:boolean) => {});    
        // }, 500);
    }
    private getUserAccessLevels():Observable<boolean>{
        let deflist = this.http.post(DataService.getUserAccessLevel,{})
                          .map((res:Response) => {
                              let respJson = res.json();
                              this.checkAuthentication(respJson);
                              if(respJson.status == "OK"){
                                //   let _tmpAccessLevels:Array<uModule> = [];
                                //   for(var i=0;i<respJson.data.length;i++){
                                //       let _tmpuParams:Array<uModParameter> = [];
                                //       if(respJson.data[i].parameters){
                                //         for(var j=0;j<respJson.data[i].parameters.length;j++){
                                //             _tmpuParams.push(new uModParameter(respJson.data[i].parameters[j].parameter_id,respJson.data[i].parameters[j].permis))
                                //         }
                                //       }
                                //       _tmpAccessLevels.push(new uModule(respJson.data[i].module_id,_tmpuParams));
                                //   }
                                //   this._accessLevels = _tmpAccessLevels;
                                this._accessLevel = respJson.data;
                                  return true;
                              }
                          })
                          .catch((error:any) => Observable.throw(error || 'Server error'))
        return deflist;
    }
    private getDataDefinitions():Observable<boolean>{
        let deflist = this.http.post(DataService.getDataDefs,{})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        // this._isDefLoaded = true;
                        this._companyName = respJson.factory.name;
                        let _depts:Array<Deparment> = [];
                        let _deptsActive:Array<Deparment> = [];
                        let list:any = respJson.departments;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _deptsActive.push(new Deparment(list[i].depId,list[i].depName,list[i].email,list[i].orderno,list[i].isActive))
                            }
                           _depts.push(new Deparment(list[i].depId,list[i].depName,list[i].email,list[i].orderno,list[i].isActive))
                        }
                        _depts.sort((_a:Deparment,_b:Deparment) => {
                            return _a.orderNo - _b.orderNo;
                        });
                        _deptsActive.sort((_a:Deparment,_b:Deparment) => {
                            return _a.orderNo - _b.orderNo;
                        });
                        this._departmentList = _depts;   
                        this._departmentListActive = _deptsActive        
                        
                        
                        let _respPers:Array<RespPerson> = [];
                        let _respPersActive:Array<RespPerson> = [];
                        list = respJson.resp_pers;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _respPersActive.push(new RespPerson(list[i].respId,list[i].respName,list[i].email,list[i].orderno,list[i].isActive));
                            }
                           _respPers.push(new RespPerson(list[i].respId,list[i].respName,list[i].email,list[i].orderno,list[i].isActive));
                        }
                        _respPers.sort((_a:RespPerson,_b:RespPerson) => {
                            return _a.orderNo - _b.orderNo;
                        });
                        _respPersActive.sort((_a:RespPerson,_b:RespPerson) => {
                            return _a.orderNo - _b.orderNo;
                        });
                        this._respPersonList = _respPers;
                        this._respPersonListActive = _respPersActive;
                    
                        let _custs:Array<Customer> = [];
                        let _custsActive:Array<Customer> = [];
                        list = respJson.customers;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _custsActive.push(new Customer(list[i].custId,list[i].custName,list[i].custEmail,list[i].orderno,list[i].isActive));
                            }
                           _custs.push(new Customer(list[i].custId,list[i].custName,list[i].custEmail,list[i].orderno,list[i].isActive));
                        }
                        _custs.sort((_a:Customer,_b:Customer) => {
                            if(_a.custName < _b.custName) return -1;
                            if(_a.custName > _b.custName) return 1;
                            return 0
                        });
                        _custsActive.sort((_a:Customer,_b:Customer) => {
                            if(_a.custName < _b.custName) return -1;
                            if(_a.custName > _b.custName) return 1;
                            return 0
                        });
                        this._customerList = _custs;
                        this._customerListActive = _custsActive;

                        let _prods:Array<ProductsList> = [];
                        let _prodsActive:Array<ProductsList> = []
                        list = respJson.products;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _prodsActive.push(new ProductsList(list[i].productId,list[i].productName,list[i].productType,list[i].productDetails,list[i].orderno,list[i].isActive));
                            }
                           _prods.push(new ProductsList(list[i].productId,list[i].productName,list[i].productType,list[i].productDetails,list[i].orderno,list[i].isActive));
                        }
                        _prods.sort((_a:ProductsList,_b:ProductsList) => {
                                return _a.orderno - _b.orderno;
                        });
                        _prodsActive.sort((_a:ProductsList,_b:ProductsList) => {
                            return _a.orderno - _b.orderno;
                        });
                        this._productList = _prods;
                        this._productActiveList = _prodsActive;
                        
                        let _prodsma:Array<Product> = [];
                        let _prodsmaActive:Array<Product> = [];
                        list = respJson.products_ma;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _prodsmaActive.push(new Product(list[i].productId,list[i].productName,list[i].productDetails,list[i].orderno,list[i].isActive));
                            }
                            _prodsma.push(new Product(list[i].productId,list[i].productName,list[i].productDetails,list[i].orderno,list[i].isActive));
                         }
                         _prodsma.sort((_a:Product,_b:Product) => {
                            return _a.orderno - _b.orderno;
                         });
                         _prodsmaActive.sort((_a:Product,_b:Product) => {
                            return _a.orderno - _b.orderno;
                        });
                         this._productListMA = _prodsma;
                         this._productListMAActive = _prodsmaActive

                        let _prodtype:Array<Product> = [];
                        let _prodtypeActive:Array<Product> = [];
                        list = respJson.product_type;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _prodtypeActive.push(new Product(list[i].productId,list[i].productName,list[i].productDetails,list[i].orderno,list[i].isActive));
                            }
                            _prodtype.push(new Product(list[i].productId,list[i].productName,list[i].productDetails,list[i].orderno,list[i].isActive));
                         }
                         _prodtype.sort((_a:Product,_b:Product) => {
                            return _a.orderno - _b.orderno;
                         });
                        _prodtypeActive.sort((_a:Product,_b:Product) => {
                            return _a.orderno - _b.orderno;
                        });
                         this._productType = _prodtype;
                         this._productTypeActive = _prodtypeActive

                        let _ohbRespPers:Array<RespPerson> = [];
                        let _ohbRespPersActive:Array<RespPerson> = [];
                        list = respJson.ohb_persons;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _ohbRespPersActive.push(new RespPerson(list[i].respId,list[i].respName,list[i].email,list[i].orderno,list[i].isActive));
                            }
                           _ohbRespPers.push(new RespPerson(list[i].respId,list[i].respName,list[i].email,list[i].orderno,list[i].isActive));
                        }
                        _ohbRespPers.sort((_a:RespPerson,_b:RespPerson) => {
                            return _a.orderNo - _b.orderNo;
                        });
                        _ohbRespPersActive.sort((_a:RespPerson,_b:RespPerson) => {
                            return _a.orderNo - _b.orderNo;
                        });
                        this._ohbRespPersonList = _ohbRespPers;
                        this._ohbRespPersonListActive = _ohbRespPersActive

                        let _pParts:Array<PolePart> = [];
                        let _pPartsActive:Array<PolePart>=[];
                        list = respJson.poles;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _pPartsActive.push(new PolePart(list[i].poleId,list[i].partDesc,list[i].productId,list[i].orderno,list[i].isActive));
                            }
                           _pParts.push(new PolePart(list[i].poleId,list[i].partDesc,list[i].productId,list[i].orderno,list[i].isActive));
                        }
                        _pParts.sort((_a:PolePart,_b:PolePart) => {
                            return _a.orderNo - _b.orderNo;
                        });
                        _pPartsActive.sort((_a:PolePart,_b:PolePart) => {
                            return _a.orderNo - _b.orderNo;
                        });
                        this._polePartList = _pParts;
                        this._polePartListActive = _pPartsActive;

                        let _wrkCat:Array<WorkCategory> = [];
                        let _wrkCatActive:Array<WorkCategory>=[];                       
                        let _mnAllocation:ManPowerAllocation;
                        let _mnAllocationActive:ManPowerAllocation;
                        list = respJson.work_categories;
                         for(var i=0;i<list.length;i++){
                             let _tsks:Array<TaskList>=[];
                             let _tsksActive:Array<TaskList>=[];
                             for(var j=0;j<list[i].tasks.length;j++){
                                 if(list[i].tasks[j].isActive){
                                    _tsksActive.push(new TaskList(list[i].tasks[j].task_id,list[i].tasks[j].task_name,list[i].tasks[j].orderno,list[i].tasks[j].isActive))
                                 }
                                _tsks.push(new TaskList(list[i].tasks[j].task_id,list[i].tasks[j].task_name,list[i].tasks[j].orderno,list[i].tasks[j].isActive))
                             }
                             _tsks.sort((_a:TaskList,_b:TaskList) => {
                                return _a.orderNo - _b.orderNo;
                             });
                             _tsksActive.sort((_a:TaskList,_b:TaskList) => {
                                return _a.orderNo - _b.orderNo;
                             });
                             if(list[i].isActive){
                                _wrkCatActive.push(new WorkCategory(list[i].work_category_id,list[i].work_category_name,list[i].orderno,_tsksActive,list[i].isActive))
                             }
                             _wrkCat.push(new WorkCategory(list[i].work_category_id,list[i].work_category_name,list[i].orderno,_tsks,list[i].isActive))
                           // _wrkCat.push(new PolePart(list[i].poleId,list[i].partDesc,list[i].orderno));
                         }
                         _wrkCat.sort((_a:WorkCategory,_b:WorkCategory) => {
                            return _a.orderNo - _b.orderNo;
                         });
                         _wrkCatActive.sort((_a:WorkCategory,_b:WorkCategory) => {
                            return _a.orderNo - _b.orderNo;
                         });
                         _mnAllocation = new ManPowerAllocation(null,_wrkCat);    
                         _mnAllocationActive = new ManPowerAllocation(null,_wrkCatActive)                   
                         this._manPowerAllocation = _mnAllocation;
                         this._manPowerAllocationActive = _mnAllocationActive;

                        let _mainprods:Array<Product> = [];
                        let _mainprodsActive:Array<Product> =[];
                         list = respJson.product_type;
                         for(var i=0;i<list.length;i++){
                             if(list[i].isActive){
                                _mainprodsActive.push(new Product(list[i].productId,list[i].productName,list[i].productDetails,list[i].orderno,list[i].isActive));
                             }
                            _mainprods.push(new Product(list[i].productId,list[i].productName,list[i].productDetails,list[i].orderno,list[i].isActive));
                          }
                            _mainprods.sort((_a:Product,_b:Product) => {
                                return _a.orderno - _b.orderno;
                            });
                            _mainprodsActive.sort((_a:Product,_b:Product) => {
                                return _a.orderno - _b.orderno;
                            });
                          this._mainProduct = _mainprods;
                          this._mainProductActive = _mainprodsActive

                          let _inspBy:Array<InspectionDoneBy>=[];
                          let _inspByActive:Array<InspectionDoneBy>=[];
                          list = respJson.inspection_done_by;
                          for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _inspByActive.push(new InspectionDoneBy(list[i].inspectionId,list[i].inspName,list[i].inspEmail,list[i].orderno,list[i].isActive));                            
                            }
                            _inspBy.push(new InspectionDoneBy(list[i].inspectionId,list[i].inspName,list[i].inspEmail,list[i].orderno,list[i].isActive));
                          }
                            _inspBy.sort((_a:InspectionDoneBy,_b:InspectionDoneBy) => {
                                return _a.orderNo - _b.orderNo;
                            });
                            _inspByActive.sort((_a:InspectionDoneBy,_b:InspectionDoneBy) => {
                                return _a.orderNo - _b.orderNo;
                            });
                        this._inspectionDoneBy = _inspBy;
                        this._inspectionDoneByActive = _inspByActive

                        //   let _subprods:Array<subProduct> = [];
                        //   let _subprodsActive:Array<subProduct> = [];
                        //   list = respJson.sub_products;
                        //   for(var i=0;i<list.length;i++){
                        //       if(list[i].isActive){
                        //         _subprodsActive.push(new subProduct(list[i].productId,list[i].subProductName,list[i].subProductId,list[i].productDetails,list[i].orderno,list[i].isActive));
                        //       }
                        //      _subprods.push(new subProduct(list[i].productId,list[i].subProductName,list[i].subProductId,list[i].productDetails,list[i].orderno,list[i].isActive));
                        //    }
                        //    _subprods.sort((_a:subProduct,_b:subProduct) => {
                        //         return _a.orderNo - _b.orderNo;
                        //     });
                        //     _subprodsActive.sort((_a:subProduct,_b:subProduct) => {
                        //          return _a.orderNo - _b.orderNo;
                        //     });
                        //    this._subProduct = _subprods;
                        //    this._subProductActive = _subprodsActive

                        let _issuereltd:Array<Def> = [];
                        let _issuereltdActive:Array<Def> = [];
                        list = respJson.issue_related_to;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _issuereltdActive.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _issuereltd.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _issuereltd.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _issuereltdActive.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._issueRelatedTo = _issuereltd;
                        this._issueRelatedActive = _issuereltdActive;
                            
                        let _ncrcaptrng:Array<Def> = [];
                        let _ncrcaptrngActive:Array<Def> = [];
                        list = respJson.ncr_capturing_stage;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _ncrcaptrngActive.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _ncrcaptrng.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _ncrcaptrng.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _ncrcaptrngActive.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._ncrCapturing = _ncrcaptrng;
                        this._ncrCapturingActive = _ncrcaptrngActive;

                        let _issuecaptrng:Array<Def> = [];
                        let _issuecaptrngActive:Array<Def> = [];
                        list = respJson.issue_capturing_station;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _issuecaptrngActive.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _issuecaptrng.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _issuecaptrng.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _issuecaptrngActive.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._issueCapturing = _issuecaptrng;
                        this._issueCapturingActive = _issuecaptrngActive;

                        let _depostnDecisn:Array<Def> = [];
                        let _depostnDecisnActive:Array<Def> = [];
                        list = respJson.disposition_decision;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _depostnDecisnActive.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _depostnDecisn.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _depostnDecisn.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _depostnDecisnActive.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._depositionDecision = _depostnDecisn;
                        this._depositionDecisionActive = _depostnDecisnActive;

                        let _status:Array<Def> = [];
                        let _statusActive:Array<Def> = [];
                        list = respJson.status_def;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _statusActive.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _status.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _status.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _statusActive.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._status = _status;
                        this._statusActive = _statusActive;

                        let _splrName:Array<Def> = [];
                        let _splrNameActive:Array<Def> = [];
                        list = respJson.supplier_name;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _splrNameActive.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _splrName.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _splrName.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _splrNameActive.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._supplierName = _splrName;
                        this._supplierNameActive = _splrNameActive;

                        let _defctCtgry:Array<Def> = [];
                        let _defctCtgryActive:Array<Def> = [];
                        list = respJson.defect_category;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _defctCtgryActive.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _defctCtgry.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _defctCtgry.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _defctCtgryActive.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._defectCategory = _defctCtgry;
                        this._defectCategoryActive = _defctCtgryActive;
                         
                        let _defctSubCtgry1:Array<Def> = [];
                        let _defctSubCtgry1Active:Array<Def> = [];
                        list = respJson.defect_subcategory_1;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _defctSubCtgry1Active.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _defctSubCtgry1.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _defctSubCtgry1.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _defctSubCtgry1Active.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._defectSubCategory1 = _defctSubCtgry1;
                        this._defectSubCategory1Active = _defctSubCtgry1Active;

                        let _defctSubCtgry2:Array<Def> = [];
                        let _defctSubCtgry2Active:Array<Def> = [];
                        list = respJson.defect_subcategory_2;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _defctSubCtgry2Active.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _defctSubCtgry2.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _defctSubCtgry2.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _defctSubCtgry2Active.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._defectSubCategory2 = _defctSubCtgry2;
                        this._defectSubCategory2Active = _defctSubCtgry2Active;

                        let _defctSubCtgry3:Array<Def> = [];
                        let _defctSubCtgry3Active:Array<Def> = [];
                        list = respJson.defect_subcategory_3;
                        for(var i=0;i<list.length;i++){
                            if(list[i].isActive){
                                _defctSubCtgry3Active.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                            }
                            _defctSubCtgry3.push(new Def(list[i].defId,list[i].defName,list[i].orderno,list[i].isActive));
                        }
                        _defctSubCtgry3.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                            _defctSubCtgry3Active.sort((_a:Def,_b:Def) => {
                                return _a.orderno - _b.orderno;
                            });
                        this._defectSubCategory3 = _defctSubCtgry3;
                        this._defectSubCategory3Active = _defctSubCtgry3Active;

                        this.itsToGembaLineIdMapping = respJson.itsToGembaLineIdMapping;
                        this.itsToGembaProductIdMapping = respJson.itsToGembaProductIdMapping;
                        this.itsToGembaStationIds = respJson.itsToGembaStationIds;

                        return true;
                    }
                    else 
                        return false; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return deflist;
    }
    private addDay(_dayTime:number):number{
        return _dayTime + (24 * 60 * 60 * 1000);
    }
    private checkAuthentication(_body){
        if(_body.status == 407){
            window.location.href = '/assets/login.html';
        }
    }
    //private functions end
    //public functions start
    loadProblemsinDateRange(_frmDate:Date, _toDate:Date):Observable<Array<ProblemToken>>{
        let problist = this.http.post(DataService.getProblemsForDateRange,{"fromTime":_frmDate.getTime(),"toTime":_toDate.getTime()})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let problems:Array<ProblemToken>=[];
                        for(var i=0;i<json.length;i++){
                            problems.push(new ProblemToken(json[i].problem,json[i].description,json[i].id,json[i].start_date,json[i].end_date,json[i].status));
                        }
                        problems.sort((a:ProblemToken,b:ProblemToken) => {
                            return a.startTime - b.startTime;
                        })
                        return problems;
                    }
                    else 
                        return []; 
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return problist;
    }

    loadProblemsForDay(_id:string,_selDate:Date):Observable<Array<ProblemDetails>>{
        let problist = this.http.post(DataService.getProblemsForDay,{"id":_id, "fromTime":_selDate.getTime(),"toTime":this.addDay(_selDate.getTime())})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let problems:Array<ProblemDetails>=[];
                        for(var i=0;i<json.length;i++){
                            let problem:ProblemDetails = this.getProblemDetailsObjFromJson(json[i]);
                            problems.push(problem);
                        }
                        problems.sort((a:ProblemDetails,b:ProblemDetails) => {
                            return a.startDate - b.startDate;
                        })
                        return problems;
                    }
                    else 
                        return []; 
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return problist;
    }
    loadPlan(_selMonth:Date):Observable<Plan>{
        let _subscrb = this.http.post(DataService.getPlan,{"selmonth":_selMonth})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                let json = respJson.data;
                let dailyProdHigh:Plan;
                dailyProdHigh = this.getPlanObjFromJson(json);
                return dailyProdHigh;
            }
            else if(respJson.status=="NONE"){
                return new Plan(_selMonth.getTime(),"",null);
            }
            else 
                return null; 
        })
        .catch((error:any) => Observable.throw(error || 'Server error'))
            return _subscrb;
    }
    loadDailyProdHighlights(_selMonth:Date):Observable<DailyProdHighlights>{
        let _subscrb = this.http.post(DataService.getDailyProdHighlight,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let dailyProdHigh:DailyProdHighlights;
                        dailyProdHigh = this.getDailyProdHighlightObjFromJson(respJson.id,json,respJson.ts);
                        return dailyProdHigh;
                    }
                    else if(respJson.status=="NONE"){
                        return new DailyProdHighlights("",_selMonth.getTime(),"",[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    getFocusCopyData(_selMonth:Date):Observable<MaterialShortage>{
        let _subscrb = this.http.post(DataService.getCopyMaterialShortage,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:MaterialShortage;
                        material = this.getMaterialShortageObjFromJson(respJson.id,json,null);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new MaterialShortage("",_selMonth.getTime(),"",[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    loadMaterialShortage(_selMonth:Date):Observable<MaterialShortage>{
        let _subscrb = this.http.post(DataService.getMaterialShortage,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:MaterialShortage;
                        material = this.getMaterialShortageObjFromJson(respJson.id,json,respJson.ts);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new MaterialShortage("",_selMonth.getTime(),"",[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    
    loadDailyDeliveryPlan(_selMonth:Date):Observable<DailyDeliveryPlan>{
        let _subscrb = this.http.post(DataService.getDailyDeliveryPlan,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:DailyDeliveryPlan;
                        material = this.getDailyDeliveryPlanObjFromJson(respJson.id,json,respJson.ts);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new DailyDeliveryPlan("",_selMonth.getTime(),"",[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }

    loadCustmrInspPlan(_selMonth:Date):Observable<CustomerInspectionPlan>{
        let _subscrb = this.http.post(DataService.getCustomerInspectionPlan,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:CustomerInspectionPlan;
                        material = this.getCustomerInspectionPlanObjFromJson(respJson.id,json,respJson.ts);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new CustomerInspectionPlan("",_selMonth.getTime(),"",[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }

    loadGreenStickerPlan(_selMonth:Date):Observable<GreenStickerPlan>{
        let _subscrb = this.http.post(DataService.getGreenStickerPlan,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:GreenStickerPlan;
                        material = this.getGreenStickerPlanObjFromJson(respJson.id,json,respJson.ts);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new GreenStickerPlan("",_selMonth.getTime(),"",[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    
    loadinprocessqualityissues(_selMonth:Date,_productLineID:string):Observable<InprocessQualityIssues>{
        let _subscrb = this.http.post(DataService.getInprocessQualityIssue_1,{"selmonth":_selMonth,'plineid':_productLineID})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:InprocessQualityIssues;
                        material = this.getInprocessQualityIssueObjFromJson(respJson.id,json,respJson.ts);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new InprocessQualityIssues("",_selMonth.getTime(),[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    loadFooterData():Observable<any>{
        let _subscrb = this.http.post(DataService.getFooterData,{})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson;
                        let material:FooterData;
                        material = this.getFooterDataObjFromJson(json.data);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new FooterData("","#eeeeee");
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    loadManPowerAllocation(_selMonth:Date):Observable<any>{
        let _subscrb = this.http.post(DataService.getManPowerAllocation,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:TaskAllocation;
                        material = this.getManPwrAllctnObjFromJson(respJson.id,json,respJson.ts);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new TaskAllocation("",_selMonth.getTime(),[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    loadCCRPAllData():Observable<CCRPStatusMonitoring>{
        let _subscrb = this.http.post(DataService.getCCRPAllData,{})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:any;
                        material = this.getCCRPAllDataObjFromJson(json);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return {"material":0,"serviceEngineer":0,"initiator":0,"others":0}
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    loadCCRPStatusMonitoring(_selMonth:Date):Observable<CCRPStatusMonitoring>{
        let _subscrb = this.http.post(DataService.getCCRPStatusMonitoring,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:CCRPStatusMonitoring;
                        material = this.getCCRPStatusObjFromJson(respJson.id,json,respJson.ts);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new CCRPStatusMonitoring("",_selMonth.getTime(),[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    getCCRPCopyData(_selMonth:Date):Observable<CCRPStatusMonitoring>{
        let _subscrb = this.http.post(DataService.getCopyCCRPStatusMonitoring,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:CCRPStatusMonitoring;
                        material = this.getCCRPStatusObjFromJson(respJson.id,json,null);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new CCRPStatusMonitoring("",_selMonth.getTime(),[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    loadProdStatusMontring(_selMonth:Date):Observable<ProductionStatusMonitoring>{
        let _subscrb = this.http.post(DataService.getProdStatusMonitoring,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:ProductionStatusMonitoring;
                        material = this.getProdStatusMtringObjFromJson(respJson.id,json,respJson.ts);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new ProductionStatusMonitoring("",_selMonth.getTime(),[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    getCopyData(_selMonth:Date):Observable<ProductionStatusMonitoring>{
        let _subscrb = this.http.post(DataService.getCopyProdStatusMonitoring,{"selmonth":_selMonth})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                let json = respJson.data;
                let material:ProductionStatusMonitoring;
                material = this.getProdStatusMtringObjFromJson(respJson.id,json,null);
                return material;
            }
            else if(respJson.status=="NONE"){
                return new ProductionStatusMonitoring("",_selMonth.getTime(),[],null);
            }
            else 
                return null; 
        })
        .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
        
    }
    getMaterialGembaCardData(_selMonth:Date,_productType:string):Observable<Array<MaterialToken>>{
        let _subscrb = this.http.post(DataService.getMaterialGembaCard,{"date":_selMonth,"productType":_productType})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                let json = respJson.data;
                let token:Array<MaterialToken>;
                    token = this.getMaterialObjFromJson(json);
                return token;
            }
            else if(respJson.status=="NONE"){
                return []
                //new PoleStockReview("",_selMonth.getTime(),null,[]);
            }
            else 
                return null; 
        })
        .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
        
    }
    getQualityGembaCardData(_selMonth:Date,_productType:string):Observable<Array<IQIToken>>{
        let _subscrb = this.http.post(DataService.getQualityGembaCard,{"date":_selMonth,"productType":_productType})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                let json = respJson.data;
                let token:Array<IQIToken>;
                    token = this.getQualityObjFromJson(json);
                return token;
            }
            else if(respJson.status=="NONE"){
                return []
                //new PoleStockReview("",_selMonth.getTime(),null,[]);
            }
            else 
                return null; 
        })
        .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
        
    }
    getPoleCopyData(_selMonth:Date):Observable<PoleStockReview>{
        let _subscrb = this.http.post(DataService.getCopyPoleStkRevw,{"selmonth":_selMonth})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                let json = respJson.data;
                let pole:PoleStockReview;
                pole = this.getPoleStockRvwObjFromJson(respJson.id,json,null);
                return pole;
            }
            else if(respJson.status=="NONE"){
                return new PoleStockReview("",_selMonth.getTime(),null,[],null);
            }
            else 
                return null; 
        })
        .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
        
    }
    loadPoleStockRevw(_selMonth:Date):Observable<PoleStockReview>{
        let _subscrb = this.http.post(DataService.getPoleStockRevw,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let material:PoleStockReview;
                        material = this.getPoleStockRvwObjFromJson(respJson.id,json,respJson.ts);
                        return material;
                    }
                    else if(respJson.status=="NONE"){
                        return new PoleStockReview("",_selMonth.getTime(),"",[],null);
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    loadEmployeeList():Observable<boolean>{
        let _sublist = this.http.post(DataService.getEmployeeList,{})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                let json = respJson.data;
                let _tmpEmpList:Array<Employee> = [];
                let _tmpEmpListActive:Array<Employee>=[];
                for(var i=0;i<json.length;i++){
                    if(json[i].isenabled !="0"){
                        _tmpEmpListActive.push(this.getEmployeeObjFromJson(json[i]))
                    }
                    _tmpEmpList.push(this.getEmployeeObjFromJson(json[i]))
                }
                this._employeeList = _tmpEmpList;
                this._employeeListActive = _tmpEmpListActive;
                return true;
            }
            else if(respJson.status=="NONE"){
                return false;
            }
            else 
                return null; 
        })
        .catch((error:any) => Observable.throw(error || 'Server error'))
        return _sublist;
    }
    loadEmailGroups():Observable<boolean>{
        let _emailgrouplist = this.http.post(DataService.getEmailGroups,{})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                return true;
            }
            else 
                return null; 
        })
        .catch((error:any) => Observable.throw(error || 'Server error'))
        return _emailgrouplist;
    }
   loadEmailGroupMapping():Observable<boolean>{
        let _emailgroupmapping = this.http.post(DataService.getEmailGroupMapping,{})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                return true;
            }
            else 
                return null; 
        })
        .catch((error:any) => Observable.throw(error || 'Server error'))
        return _emailgroupmapping;
    }
    loadNwcmTreeStatus(_selMonth:Date):Observable<NWCMStatusMonthData>{
        let _subscrb = this.http.post(DataService.getNwcmTreeStatus,{"selmonth":_selMonth})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        return this.getNwcmMonthDataObjFromJson(respJson.id,json,respJson.ts);
                    }
                    else if(respJson.status=="NONE"){
                        return null;
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }
    loadShortageData(_shortageIds:Array<string>):Observable<Array<MSCToken>>{
        let _subscrb = this.http.post(DataService.getMaterialShortageData,{"shortIds":_shortageIds})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        return this.getMaterialShortageTokenArrFromJson(json);
                    }
                    else if(respJson.status=="NONE"){
                        return [];
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }

    getRCCatCssClass(_catRefId:string):string{
        let rcCat:RootCauseCategory = this._rootCauseCategories.find((_cat:RootCauseCategory) => {
            return _cat.refId == _catRefId;
        })

        if(rcCat) return rcCat.cssClass;
        return '';
    }
    getRCCatName(_catRefId:string):string{
        let rcCat:RootCauseCategory = this._rootCauseCategories.find((_cat:RootCauseCategory) => {
            return _cat.refId == _catRefId;
        })

        if(rcCat) return rcCat.displayName;
        return '';
    }
    getPlanObjFromJson(_json:any):Plan{
        let temp:Plan = new Plan(_json[0].selmonth,_json[0].description,_json[0]._ts)
        return temp;
    }
    getDailyProdHighlightObjFromJson(_id:string, _json:any,_docTs:number):DailyProdHighlights{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<DPHDayToken> = [];

        for(var i=0;i<_json.days.length;i++){
            let tmpday = _json.days[i];
            let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
            if(selDate){
                let tmpdayToken:Array<DPHToken> = [];
                for(var j=0;j<tmpday.rows.length;j++){
                    let tmpRow = tmpday.rows[j];
                    tmpdayToken.push(new DPHToken(tmpRow.row_id, tmpRow.productId, tmpRow.productType, tmpRow.customerId,tmpRow.quantity,tmpRow.shortage,tmpRow.status,tmpRow.creationDate,tmpRow.shortageNotes,tmpRow.severityValue));
                }
                tmpdayTokens.push(new DPHDayToken(selDate,tmpdayToken));
            }
            
        }
        
        let _prodHighObj:DailyProdHighlights = new DailyProdHighlights(_id,tmpMonthObj.getTime(),_json.plan.text,tmpdayTokens,_docTs);
        return _prodHighObj;
    }
    getMaterialShortageObjFromJson(_id:string, _json:any,_docTs:number):MaterialShortage{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<MSCDayToken> = [];

        for(var i=0;i<_json.days.length;i++){
            let tmpday = _json.days[i];
            let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
            if(selDate){
                let tmpdayToken:Array<MSCToken> = [];   
                for(var j=0;j<tmpday.rows.length;j++){
                    let tmpRow = tmpday.rows[j];
                    tmpdayToken.push(new MSCToken(tmpRow.shortage_id,tmpRow.particulars,tmpRow.firstresolutionDateNum,tmpRow.resolutionDateNum,tmpRow.delayeddays,tmpRow.ownerName,tmpRow.status,tmpRow.creationDate));
                }
                tmpdayTokens.push(new MSCDayToken(selDate, tmpdayToken));
            }            
        }
        
        let _matrl:MaterialShortage = new MaterialShortage(_id,tmpMonthObj.getTime(),_json.plan.text,tmpdayTokens,_docTs);
        return _matrl;
    }
    
    getDailyDeliveryPlanObjFromJson(_id:string, _json:any,_docTs:number):DailyDeliveryPlan{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<DSPDayToken> = [];

        for(var i=0;i<_json.days.length;i++){
            let tmpday = _json.days[i];
            let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
            if(selDate){
                let tmpdayToken:Array<DSPToken> = [];
                for(var j=0;j<tmpday.rows.length;j++){
                    let tmpRow = tmpday.rows[j];
                    tmpdayToken.push(new DSPToken(tmpRow.type1,tmpRow.type2,tmpRow.customerName,tmpRow.quantity,tmpRow.cb,
                                                  tmpRow.structure,tmpRow.di,tmpRow.respPrsn,tmpRow.dateNum,tmpRow.status,tmpRow.remark,tmpRow.creationDate));
                }
                tmpdayTokens.push(new DSPDayToken(selDate, tmpdayToken));
            }
            
        }
        
        let _daldel:DailyDeliveryPlan = new DailyDeliveryPlan(_id,tmpMonthObj.getTime(),_json.plan.text,tmpdayTokens,_docTs);
        return _daldel;
    }

    getCustomerInspectionPlanObjFromJson(_id:string, _json:any,_docTs:number):CustomerInspectionPlan{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<CIPDayToken> = [];

        for(var i=0;i<_json.days.length;i++){
            let tmpday = _json.days[i];
            let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
            if(selDate){
                let tmpdayToken:Array<CIPToken> = [];
                for(var j=0;j<tmpday.rows.length;j++){
                    let tmpRow = tmpday.rows[j];
                    tmpdayToken.push(new CIPToken(tmpRow.productName,tmpRow.customerName,tmpRow.inspectionDoneBy,tmpRow.quantity,tmpRow.witnessQuantity,tmpRow.cb,tmpRow.dateNum,
                        tmpRow.respPrsn,tmpRow.createdDate));
                }
                tmpdayTokens.push(new CIPDayToken(selDate,tmpdayToken));
            }
            
        }
        
        let _daldel:CustomerInspectionPlan = new CustomerInspectionPlan(_id,tmpMonthObj.getTime(),_json.plan.text,tmpdayTokens,_docTs);
        return _daldel;
    }
    
    getGreenStickerPlanObjFromJson(_id:string, _json:any,_docTs:number):GreenStickerPlan{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<GSPDayToken> = [];

        for(var i=0;i<_json.days.length;i++){
            let tmpday = _json.days[i];
            let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
            let tmpdayToken:Array<GSPToken> = [];
            for(var j=0;j<tmpday.rows.length;j++){
                let tmpRow = tmpday.rows[j];
                tmpdayToken.push(new GSPToken(tmpRow.row_id,tmpRow.productName,tmpRow.productType,tmpRow.customerName,tmpRow.quantity,tmpRow.shortage,tmpRow.status,tmpRow.shortageNotes,tmpRow.createdDate,tmpRow.severityValue));
            }
            tmpdayTokens.push(new GSPDayToken(selDate,tmpdayToken));
        }
        
        let _daldel:GreenStickerPlan = new GreenStickerPlan(_id,tmpMonthObj.getTime(),_json.plan.text,tmpdayTokens,_docTs);
        return _daldel;
    }
    getFooterDataObjFromJson(_json:any):FooterData{
        let dt:FooterData = new FooterData(_json[0].footer_data, _json[0].footer_back)
        return dt;
    }
    getInprocessQualityIssueObjFromJson(_id:string, _json:any,_docTs:number):InprocessQualityIssues{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
     //   let tmpDate:number = parseInt(monthStr.substring(6))
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<IQIDayToken> = [];

        for(var i=0;i<_json.days.length;i++){
            let tmpday = _json.days[i];
            let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
            if(selDate){
                let tmpdayToken:Array<IQIToken> = [];
                for(var j=0;j<tmpday.rows.length;j++){
                    let tmpRow = tmpday.rows[j];
                    tmpdayToken.push(new IQIToken(tmpRow.rowId,tmpRow.productName,tmpRow.productType,tmpRow.productDesc,tmpRow.quantity,tmpRow.issueRelated,
                        tmpRow.supplierName,tmpRow.ncrCapturing,tmpRow.issueCapturing,tmpRow.defectCategory,tmpRow.defectSubCategory1,
                        tmpRow.defectSubCategory2,tmpRow.defectSubCategory3,tmpRow.rootCause,tmpRow.dispositionDecision,
                        tmpRow.actionDecided,tmpRow.preventiveAction,tmpRow.respPrsn,tmpRow.targetDateNum,tmpRow.status,tmpRow.shortageNotes,tmpRow.createdDate,tmpRow.severityValue,null));
                }
                tmpdayTokens.push(new IQIDayToken(selDate,tmpdayToken));
            }
        }
        
        let _daldel:InprocessQualityIssues = new InprocessQualityIssues(_id,tmpMonthObj.getTime(),tmpdayTokens,_docTs);
        return _daldel;
    }
    getCCRPStatusObjFromJson(_id:string, _json:any,_docTs:number):CCRPStatusMonitoring{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<CCRPDayToken> = [];
        
                for(var i=0;i<_json.days.length;i++){
                    let tmpday = _json.days[i];
                    let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
                    if(selDate){
                        let tmpdayToken:Array<CCRPSMToken> = [];
                        for(var j=0;j<tmpday.rows.length;j++){
                            let tmpRow = tmpday.rows[j];
                            tmpdayToken.push(new CCRPSMToken(tmpRow.ccrpNo,tmpRow.customer,tmpRow.reason,tmpRow.materialDesc,tmpRow.respPrsn,tmpRow.targetDateNum,tmpRow.status,tmpRow.closedDateNum,tmpRow.createdDate));
                        }
                        tmpdayTokens.push(new CCRPDayToken(selDate,tmpday.tillDateRaisedCCRP,tmpday.tillDateClosedCCRP,
                            tmpday.openCCRPOnDate,tmpday.CCRPOpenForMaterials,tmpday.CCRPOpenServiceEng,tmpday.CCRPWaitingForClosure,tmpdayToken));
                    }
                }
        let _daldel:CCRPStatusMonitoring = new CCRPStatusMonitoring(_id,tmpMonthObj.getTime(),tmpdayTokens,_docTs);
        return _daldel;
    }
    getCCRPAllDataObjFromJson(_json:any):any{
        var _material = 0;
        var _serviceEngineer = 0;
        var _initiator = 0;
        var _others = 0;
        for(var i=0;i<_json.length;i++){
            for(var j=0;j<_json[i].data.days.length;j++){
                var tmp = _json[i].data.days[j];
                for(var k=0;k<tmp.rows.length;k++){
                    if(tmp.rows[k].status == 'in process'){
                        if(tmp.rows[k].reason == 'waiting for material'){
                            _material= _material+1;
                        }
                        else if(tmp.rows[k].reason == 'waiting for service engineer'){
                            _serviceEngineer = _serviceEngineer+1;
                        }
                        else if(tmp.rows[k].reason =='waiting for closure from initiator'){
                            _initiator = _initiator +1;
                        }
                        else if(tmp.rows[k].reason =='other'){
                            _others = _others+1;
                        }
                    }
                }
            }
        }
        var _returnparam = {"material":_material,"serviceEngineer":_serviceEngineer,"initiator":_initiator,"others":_others}
        return _returnparam;
    }
    getManPwrAllctnObjFromJson(_id:string, _json:any,_docTs:number):TaskAllocation{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<TaskDayToken> = [];
        
                for(var i=0;i<_json.days.length;i++){
                    let tmpday = _json.days[i];
                    let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
                    if(selDate){
                        let tmpdayToken:Array<TaskLinked> = [];
                        for(var j=0;j<tmpday.rows.length;j++){
                            let tmpRow = tmpday.rows[j];
                            let users:Array<addUser>=[];
                                for(var k=0;k<tmpRow.users.length;k++){
                                    users.push(new addUser(tmpRow.users[k].email,tmpRow.users[k].displayName));
                                }
                            tmpdayToken.push(new TaskLinked(tmpRow.workCategoryId,tmpRow.workCategoryName,tmpRow.taskId,tmpRow.taskName,users,tmpRow.quantity));
                        }
                        tmpdayTokens.push(new TaskDayToken(selDate,tmpdayToken));
                    }
                }
        let _daldel:TaskAllocation = new TaskAllocation(_id,tmpMonthObj.getTime(),tmpdayTokens,_docTs);
        return _daldel;
    }
    // getEmpObjFromJson(_id:string, _json:any):Array<Employee>{
    //     let empList:Array<Employee> = [];       
    //      for(var i=0;i<_json.length;i++){
    //         empList.push(new Employee(_json[i].Id,_json[i].Name,_json[i].PhotoLink,_json[i].DateOfJoining,_json[i].Initials,_json[i].Email))
    //      }      
    //     return empList;
    // }
    getNwcmMonthDataObjFromJson(_id:string,_json:any,_docTs:number):NWCMStatusMonthData{
        let monthStr:string = _json.selmonth + '';
        // let tmpYear:number = parseInt(monthStr.substring(0,4));
        // let tmpMonth:number = parseInt(monthStr.substring(4));
        // let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpPointTokens:Array<NWCMPointData> = [];

        for(var i=0;i<_json.kpistatus.length;i++){
            let tmpkpi = _json.kpistatus[i];
            let histTokens:Array<NWCMHistoryToken> = [];
            if(tmpkpi.history && tmpkpi.history.length > 0){
                for(var j=0;j<tmpkpi.history.length;j++){
                    var histToken = tmpkpi.history[j];
                    histTokens.push(new NWCMHistoryToken(histToken.user,histToken.updatetime,histToken.fromstatus,histToken.tostatus));
                }
            }
            tmpPointTokens.push(new NWCMPointData(tmpkpi.kpiid,tmpkpi.kpistatus,tmpkpi.kpi_image_ref, histTokens));
        }
        
        let _nwcmStatMonthData:NWCMStatusMonthData = new NWCMStatusMonthData(_id,monthStr,tmpPointTokens,_docTs)
        return _nwcmStatMonthData;
    }
    getMaterialShortageTokenArrFromJson(_json:any):Array<MSCToken>{
        let mscTokens:Array<MSCToken> = [];
        for(var i=0;i<_json.length;i++){
            mscTokens.push(new MSCToken(_json[i].shortage_id,_json[i].particulars,_json[i].firstresolutionDateNum,_json[i].resolutionDateNum,_json[i].delayeddays,_json[i].ownerName,_json[i].status,_json[i].creationDate));
        }
        return mscTokens;
    }
    getEmpObjFromJson(_id:string, _json:any):Array<Employee>{
        let empList:Array<Employee> = [];       
         for(var i=0;i<_json.length;i++){
            empList.push(new Employee(_json[i].Id,_json[i].Name,_json[i].PhotoLink,_json[i].DateOfJoining,_json[i].Initials,_json[i].Email,_json[i].isEnabled))
         }      
        ///let _daldel: = new TaskAllocation(_id,tmpdayTokens)
        return empList;
    }
    getProdStatusMtringObjFromJson(_id:string, _json:any,_docTs:number):ProductionStatusMonitoring{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<PSMDayToken> = [];
        
                for(var i=0;i<_json.days.length;i++){
                    let tmpday = _json.days[i];
                    let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
                    if(selDate){
                        let tmpdayToken:Array<PSMToken> = [];
                        for(var j=0;j<tmpday.rows.length;j++){
                            let tmpRow = tmpday.rows[j];
                            tmpdayToken.push(new PSMToken(tmpRow.productName,tmpRow.scheduleMnth,tmpRow.matreceivedfor,tmpRow.matyetreceivedfor,tmpRow.tillDatePrdction,tmpRow.balanceQty,tmpRow.ystrdyProductin,tmpRow.tdayProdctonPlan,tmpRow.dateTestedQty,tmpRow.dateGreenSticker,tmpRow.balanceGreenStickerQty,tmpRow.createdDate));
                        }
                        tmpdayTokens.push(new PSMDayToken(selDate,tmpdayToken));
                    }
                }
        let _daldel:ProductionStatusMonitoring = new ProductionStatusMonitoring(_id,tmpMonthObj.getTime(),tmpdayTokens,_docTs);
        return _daldel;
    }
    getEmployeeObjFromJson(_json:any):Employee{
        let _tmpObj:Employee = new Employee(_json.emp_id,_json.emp_name,_json.emp_photo,
                                            _json.doj,_json.emp_initials,_json.emp_email,_json.isenabled);
        return _tmpObj;
    }
    getPoleStockRvwObjFromJson(_id:string, _json:any,_docTs:number):PoleStockReview{
        let monthStr:string = _json.selmonth + '';
        let tmpYear:number = parseInt(monthStr.substring(0,4));
        let tmpMonth:number = parseInt(monthStr.substring(4));
        let tmpMonthObj:Date = new Date(tmpYear,tmpMonth-1,1);
        let tmpdayTokens:Array<PSRDayToken> = [];

        for(var i=0;i<_json.days.length;i++){
            let tmpday = _json.days[i];
            let selDate:Date = GenService.parseDateString(tmpday.seldate,'YYYYMMDD');
            if(selDate){
                let tmpdayToken:Array<PSRToken> = [];
                for(var j=0;j<tmpday.rows.length;j++){
                    let tmpRow = tmpday.rows[j];
                    tmpdayToken.push(new PSRToken(tmpRow.productName,tmpRow.poleDescPartNo,tmpRow.quantity,tmpRow.createdDate));
                }
                tmpdayTokens.push(new PSRDayToken(selDate, tmpdayToken));
            }            
        }
        
        let _matrl:PoleStockReview = new PoleStockReview(_id,tmpMonthObj.getTime(),_json.plan.text,tmpdayTokens,_docTs);
        return _matrl;
    }
    getQualityObjFromJson(_json:any):Array<IQIToken>{
        let _data:Array<IQIToken>=[];
        for(var i=0;i<_json.length;i++){
            var tmpRow = _json[i].row
            let _selDate:Date = GenService.parseDateString(_json[i].seldate+'',"YYYYMMDD");
            _data.push(new IQIToken(tmpRow.rowId,tmpRow.productName,tmpRow.productType,tmpRow.productDesc,tmpRow.quantity,tmpRow.issueRelated,
                tmpRow.supplierName,tmpRow.ncrCapturing,tmpRow.issueCapturing,tmpRow.defectCategory,tmpRow.defectSubCategory1,
                tmpRow.defectSubCategory2,tmpRow.defectSubCategory3,tmpRow.rootCause,tmpRow.dispositionDecision,
                tmpRow.actionDecided,tmpRow.preventiveAction,tmpRow.respPrsn,tmpRow.targetDateNum,tmpRow.status,tmpRow.shortageNotes,tmpRow.createdDate,tmpRow.severityValue,_selDate))
        }
        return _data
    }
    getMaterialObjFromJson(_json:any):Array<MaterialToken>{
        let _data:Array<MaterialToken>=[];
        for(var i=0;i<_json.length;i++){
            var _tmp1 = _json[i].row
            _data.push(new MaterialToken(_tmp1.row_id,_tmp1.productName,_tmp1.productType,_tmp1.customerName,_tmp1.quantity,_tmp1.shortage,_tmp1.status,_tmp1.createdDate,_tmp1.shortageNotes,_tmp1.severityValue))
        }
        return _data
    }
        
    getProblemDetailsObjFromJson(_json:any):ProblemDetails{
        let _causes:Array<ProblemCause> = [];
        if(_json.causes){
            for(var j=0;j<_json.causes.length;j++){
                _causes.push(new ProblemCause(_json.causes[j].type,_json.causes[j].text,_json.causes[j].log_doc,(_json.causes[j].isenabled ? _json.causes[j].isenabled : false)));
            }
        }
        let _propAction:string = null
        if(_json.proposed_action){
            _propAction = _json.proposed_action
        }
        let _actions:Array<ProblemAction> = [];
        if(_json.actions){
            for(var j=0;j<_json.actions.length;j++){
                _actions.push(new ProblemAction(_json.actions[j].text,_json.actions[j].function,_json.actions[j].responsible,
                                                _json.actions[j].target_timestamp,_json.actions[j].log_doc));
            }
        }
        let _comments:Array<ProblemComment> = [];
        if(_json.comments){
            for(var j=0;j<_json.comments.length;j++){
                _comments.push(new ProblemComment(_json.comments[j].comment,_json.comments[j].timestamp,_json.comments[j].commented_user,_json.comments[j].status))
            }
        }

        return new ProblemDetails(_json.problem,_json.description,_json.id,_json.start_date,_json.end_date, _json.root_cause,
                                _causes,_propAction,_actions,_comments,_json.status,_json.ts)
    }
    getProblemDetailsJsonFromObj(_prob:ProblemDetails):any{
        let _json:any = {};
        _json.id = _prob.id;
        _json.problem = _prob.header
        _json.description = _prob.description;
        _json.end_date = _prob.endDate;
        _json.start_date = _prob.startDate;
        _json.root_cause = _prob.rootCause;
        _json.causes = [];
        _json.ts = _prob.docTs;

        for(var i=0;i<_prob.causes.length;i++){
            let _cause:ProblemCause = _prob.causes[i];
            _json.causes.push({"type":_cause.typeofCategory,"text":_cause.details,"isenabled":_cause.isEnabled});
        }
        _json.proposed_action = _prob.proposedAction;
        _json.actions = [];
        for(var i=0;i<_prob.actions.length;i++){
            let _action:ProblemAction = _prob.actions[i];
            _json.actions.push({"text":_action.propAction,"function":_action.function,"responsible":_action.responsible,"target_timestamp":_action.targetTimeStamp})
        }
        _json.comments = [];
        for(var i=0;i<_prob.comments.length;i++){
            let _comment:ProblemComment = _prob.comments[i];
            _json.comments.push({"comment":_comment.comment,"timestamp":_comment.commentTimeStamp,"status":_comment.status,"commented_user":_comment.user});
        }
        _json.status = _prob.status;
        return _json;
    }
    getDailyProdHighJsonFromObj(_dlyProdHigh: DailyProdHighlights): any {
        let _json: any = {};
        _json.id = _dlyProdHigh.id;
        _json.selmonth = _dlyProdHigh.monthDateNum;
        _json.plan = _dlyProdHigh.plan;
        _json.days = [];
        _json.mat_short_rows = [];
        _json.ts = _dlyProdHigh.docTs;

        for (var i = 0; i < _dlyProdHigh.dayTokens.length; i++) {
            let _dayToken: DPHDayToken = _dlyProdHigh.dayTokens[i];
            let _dayJson: any = {};
            let _seldate = GenService.getDateFormatStr(_dayToken.selDate, 'YYYYMMDD');
            _dayJson.seldate = _seldate;
            _dayJson.rows = [];
            for (var j = 0; j < _dayToken.dateTokens.length; j++) {
                _dayJson.rows.push({
                    "row_id": _dayToken.dateTokens[j].rowId,
                    // "material_shortage_ids":
                    //     (_dayToken.dateTokens[j].shortage == 'yes' ? _dayToken.dateTokens[j].materialShortageIds : []),
                    "productId": _dayToken.dateTokens[j].productId,
                    "productType":_dayToken.dateTokens[j].productType,
                    "customerId": _dayToken.dateTokens[j].customerId,
                    "quantity": _dayToken.dateTokens[j].quantity,
                    "shortage": _dayToken.dateTokens[j].shortage,
                    "status":_dayToken.dateTokens[j].status,
                    "creationDate":_dayToken.dateTokens[j].creationDate,
                    "shortageNotes":_dayToken.dateTokens[j].shortageNotes,
                    "severityValue":_dayToken.dateTokens[j].severityValue
                });

                // if (_dayToken.dateTokens[j].shortage == 'yes') {
                //     for (var k = 0; k < _dayToken.dateTokens[j].materialShortageData.length; k++) {
                //         let _tmpToken: MSCToken = _dayToken.dateTokens[j].materialShortageData[k];
                    

                //         _json.mat_short_rows.push(
                //             {
                //                 "shortage_id": _tmpToken.materialShortageId,
                //                 "shortage_source": _tmpToken.materialShortageSrc,
                //                 "ref_row_id": _dayToken.dateTokens[j].rowId,
                //                 "particulars": _tmpToken.particulars,
                //                 "resolutionDateNum": _tmpToken.resolutionDateNum,
                //                 "ownerName": _tmpToken.ownerName,
                //                 "selmonth": _dlyProdHigh.monthDateNum,
                //                 "seldate": _seldate,                                
                //                 "status": _tmpToken.status,
                //                 "creationDate":_tmpToken.creationDate
                //             }
                //         );
                //     }
                // }
            }
            _json.days.push(_dayJson);
        }
        return _json;
    }
    getPlanJsonFromObj(_dl:Plan):any{
        let _json:any = {};
        _json= {"selmonth":_dl.monthDateNum,"description":_dl.description,"ts":_dl.docTs}
        return _json;
    }
    getMaterialShortageJsonFromObj(_mtrlShrt:MaterialShortage):any{
        let _json:any = {};
        _json.id = _mtrlShrt.id;
        _json.selmonth = _mtrlShrt.monthDateNum;
        _json.plan = _mtrlShrt.plan;
        _json.days = [];
        _json.ts = _mtrlShrt.docTs;

        for(var i=0;i<_mtrlShrt.dayTokens.length;i++){
            let _dayToken:MSCDayToken = _mtrlShrt.dayTokens[i];
            let _dayJson:any = {};
            _dayJson.seldate = GenService.getDateFormatStr(_dayToken.selDate,'YYYYMMDD');
            _dayJson.rows = [];
            for(var j=0;j<_dayToken.dateTokens.length;j++){
                _dayJson.rows.push({
                                "shortage_id": _dayToken.dateTokens[j].materialShortageId,
                                "particulars":_dayToken.dateTokens[j].particulars,
                                "firstresolutionDateNum":_dayToken.dateTokens[j].firstresolutionDateNum,
                                "resolutionDateNum":_dayToken.dateTokens[j].resolutionDateNum,
                                "ownerName":_dayToken.dateTokens[j].ownerName,
                            "status":_dayToken.dateTokens[j].status,
                        "creationDate":_dayToken.dateTokens[j].creationDate});
            }
            _json.days.push(_dayJson);
        }
        return _json;
    }
    
    getPoleStockReviewJsonFromObj(_mtrlShrt:PoleStockReview):any{
        let _json:any = {};
        _json.id = _mtrlShrt.id;
        _json.selmonth = _mtrlShrt.monthDateNum;
        _json.plan = _mtrlShrt.plan;
        _json.days = [];
        _json.ts = _mtrlShrt.docTs;

        for(var i=0;i<_mtrlShrt.dayTokens.length;i++){
            let _dayToken:PSRDayToken = _mtrlShrt.dayTokens[i];
            let _dayJson:any = {};
            _dayJson.seldate = GenService.getDateFormatStr(_dayToken.selDate,'YYYYMMDD');
            _dayJson.rows = [];
            for(var j=0;j<_dayToken.dateTokens.length;j++){
                _dayJson.rows.push({"productName":_dayToken.dateTokens[j].productName,
                                    "poleDescPartNo":_dayToken.dateTokens[j].poleDescPartNo,
                                    "quantity":_dayToken.dateTokens[j].quantity,
                                "createdDate":_dayToken.dateTokens[j].creationDate});
            }
            _json.days.push(_dayJson);
        }
        return _json;
    }
    getDailyDeliveryPlanJsonFromObj(_obj:DailyDeliveryPlan):any{
        let _json:any = {};
        _json.id = _obj.id;
        _json.selmonth = _obj.monthDateNum;
        _json.plan = _obj.plan;
        _json.days = [];
        _json.ts =  _obj.docTs;

        for(var i=0;i<_obj.dayTokens.length;i++){
            let _dayToken:DSPDayToken = _obj.dayTokens[i];
            let _dayJson:any = {};
            _dayJson.seldate = GenService.getDateFormatStr(_dayToken.selDate,'YYYYMMDD');
            _dayJson.rows = [];
            for(var j=0;j<_dayToken.dateTokens.length;j++){
                _dayJson.rows.push({"type1":_dayToken.dateTokens[j].type1,
                                    "type2":_dayToken.dateTokens[j].type2,
                                    "customerName":_dayToken.dateTokens[j].customerName,
                                    "quantity":_dayToken.dateTokens[j].quantity,
                                    "cb":_dayToken.dateTokens[j].cb,
                                    "structure":_dayToken.dateTokens[j].structure,
                                    "di":_dayToken.dateTokens[j].di,
                                    "respPrsn":_dayToken.dateTokens[j].respPrsn,
                                    "dateNum":_dayToken.dateTokens[j].dateNum,
                                    "status":_dayToken.dateTokens[j].status,
                                    "remark":_dayToken.dateTokens[j].remark,
                                "creationDate":_dayToken.dateTokens[j].creationDate});
            }
            _json.days.push(_dayJson);
        }
        return _json;
    }
    getCustomerInspectionPlanJsonFromObj(_Obj:CustomerInspectionPlan):any{
        let _json:any = {};
        _json.id = _Obj.id;
        _json.selmonth = _Obj.monthDateNum;
        _json.plan = _Obj.plan;
        _json.days = [];
        _json.ts = _Obj.docTs;

        for(var i=0;i<_Obj.dayTokens.length;i++){
            let _dayToken:CIPDayToken = _Obj.dayTokens[i];
            let _dayJson:any = {};
            _dayJson.seldate = GenService.getDateFormatStr(_dayToken.selDate,'YYYYMMDD');
            _dayJson.rows = [];
            for(var j=0;j<_dayToken.dateTokens.length;j++){
                _dayJson.rows.push({"productName":_dayToken.dateTokens[j].productName,
                                    "customerName":_dayToken.dateTokens[j].customerName,
                                    "inspectionDoneBy":_dayToken.dateTokens[j].inspectionDoneBy,
                                    "quantity":_dayToken.dateTokens[j].quantity,
                                    "witnessQuantity":_dayToken.dateTokens[j].witnessQuantity,
                                    "cb":_dayToken.dateTokens[j].cb,
                                    "dateNum":_dayToken.dateTokens[j].dateNum,
                                    "respPrsn":_dayToken.dateTokens[j].respPrsn,
                                "createdDate":_dayToken.dateTokens[j].creationDate});
            }
            _json.days.push(_dayJson);
        }
        return _json;
    }
    getGreenStickerPlanJsonFromObj(_Obj:GreenStickerPlan):any{
        let _json:any = {};
        _json.id = _Obj.id;
        _json.selmonth = _Obj.monthDateNum;
        _json.plan = _Obj.plan;
        _json.days = [];
        _json.mat_short_rows = [];
        _json.ts = _Obj.docTs;

        for(var i=0;i<_Obj.dayTokens.length;i++){
            let _dayToken:GSPDayToken = _Obj.dayTokens[i];
            let _dayJson:any = {};
            let _seldate = GenService.getDateFormatStr(_dayToken.selDate,'YYYYMMDD');
            _dayJson.seldate = _seldate;
            _dayJson.rows = [];
            for(var j=0;j<_dayToken.dateTokens.length;j++){
                _dayJson.rows.push({
                                    "row_id":_dayToken.dateTokens[j].rowId,
                                    // "material_shortage_ids":
                                    // (_dayToken.dateTokens[j].shortage == 'yes' ? _dayToken.dateTokens[j].materialShortageIds : []),
                                    "productName":_dayToken.dateTokens[j].productName,
                                    "productType":_dayToken.dateTokens[j].productType,
                                    "customerName":_dayToken.dateTokens[j].customerName,
                                    "quantity":_dayToken.dateTokens[j].quantity,
                                    "shortage":_dayToken.dateTokens[j].shortage,
                                    "status":_dayToken.dateTokens[j].status,
                                    "shortageNotes":_dayToken.dateTokens[j].shortageNotes,
                                    "createdDate":_dayToken.dateTokens[j].creationDate,
                                    "severityValue":_dayToken.dateTokens[j].severityValue
                                    //,
                                    //"creationDate":_dayToken.dateTokens[j].creationDate
                                });
                // if(_dayToken.dateTokens[j].shortage == 'yes'){
                //     for(var k=0;k<_dayToken.dateTokens[j].materialShortageData.length;k++){
                //         let _tmpToken:MSCToken = _dayToken.dateTokens[j].materialShortageData[k];

                //         _json.mat_short_rows.push(
                //             {
                //                 "shortage_id": _tmpToken.materialShortageId,
                //                 "shortage_source": _tmpToken.materialShortageSrc,
                //                 "ref_row_id":_dayToken.dateTokens[j].rowId,
                //                 "particulars": _tmpToken.particulars,
                //                 "resolutionDateNum": _tmpToken.resolutionDateNum,
                //                 "ownerName": _tmpToken.ownerName,
                //                 "status":_tmpToken.status,
                //                 "selmonth": _Obj.monthDateNum,
                //                 "seldate" : _seldate
                //             }
                //         );
                //     }
                // }
            }
            _json.days.push(_dayJson);
        }
        return _json;
    }
    getCCRPStatusMtrJsonFromObj(_mtrlShrt:CCRPStatusMonitoring):any{
        let _json:any = {};
        _json.id = _mtrlShrt.id;
        _json.selmonth = _mtrlShrt.monthDateNum;
        _json.days = [];
        _json.ts = _mtrlShrt.docTs;

        for(var i=0;i<_mtrlShrt.dayTokens.length;i++){
            let _dayToken:CCRPDayToken = _mtrlShrt.dayTokens[i];
            let _dayJson:any = {};
            _dayJson.seldate = GenService.getDateFormatStr(_dayToken.selDate,'YYYYMMDD');
            _dayJson.tillDateRaisedCCRP = _dayToken.tillDateRaisedCCRP;
            _dayJson.tillDateClosedCCRP = _dayToken.tillDateClosedCCRP;
            _dayJson.openCCRPOnDate = _dayToken.openCCRPOnDate;
            _dayJson.CCRPOpenForMaterials = _dayToken.CCRPOpenForMaterials;
            _dayJson.CCRPOpenServiceEng = _dayToken.CCRPOpenServiceEng;
            _dayJson.CCRPWaitingForClosure = _dayToken.CCRPWaitingForClosure;
            _dayJson.rows = [];
            for(var j=0;j<_dayToken.dateTokens.length;j++){
                _dayJson.rows.push({"ccrpNo":_dayToken.dateTokens[j].ccrpNo,"customer":_dayToken.dateTokens[j].customer,"reason":_dayToken.dateTokens[j].reason,"materialDesc":_dayToken.dateTokens[j].materialDesc,"respPrsn":_dayToken.dateTokens[j].respPrsn,"targetDateNum":_dayToken.dateTokens[j].targetDateNum,"status":_dayToken.dateTokens[j].status,"closedDateNum":_dayToken.dateTokens[j].closedDateNum,"createdDate":_dayToken.dateTokens[j].createdDate});
            }
            _json.days.push(_dayJson);
        }
        return _json;
    }
    getProdStatusMtrJsonFromObj(_mtrlShrt:ProductionStatusMonitoring):any{
        let _json:any = {};
        _json.id = _mtrlShrt.id;
        _json.selmonth = _mtrlShrt.monthDateNum;
        _json.days = [];
        _json.ts = _mtrlShrt.docTs;

        for(var i=0;i<_mtrlShrt.dayTokens.length;i++){
            let _dayToken:PSMDayToken = _mtrlShrt.dayTokens[i];
            let _dayJson:any = {};
            _dayJson.seldate = GenService.getDateFormatStr(_dayToken.selDate,'YYYYMMDD');
            _dayJson.rows = [];
            for(var j=0;j<_dayToken.dateTokens.length;j++){
                _dayJson.rows.push({
                    "productName":_dayToken.dateTokens[j].productId,"scheduleMnth":_dayToken.dateTokens[j].scheduleMnth,"matreceivedfor":_dayToken.dateTokens[j].matreceivedfor,
                    "matyetreceivedfor":_dayToken.dateTokens[j].matyetreceivedfor,"tillDatePrdction":_dayToken.dateTokens[j].tillDatePrdction,"balanceQty":_dayToken.dateTokens[j].balanceQty,
                "ystrdyProductin":_dayToken.dateTokens[j].ystrdyProductin,"tdayProdctonPlan":_dayToken.dateTokens[j].tdayProdctonPlan,
                "dateTestedQty":_dayToken.dateTokens[j].dateTestedQty,"dateGreenSticker":_dayToken.dateTokens[j].dateGreenSticker,
                "balanceGreenStickerQty":_dayToken.dateTokens[j].balanceGreenStickerQty,"createdDate":_dayToken.dateTokens[j].creationDate});
            }
            _json.days.push(_dayJson);
        }
        return _json;
    }
    getNWCMStatusJsonFromObj(_nwcmStatusData:NWCMStatusMonthData):any{
        let _json:any = {};
        _json.id = _nwcmStatusData.ID;
        _json.selmonth = _nwcmStatusData.SelMonth;
        _json.kpistatus = [];
        _json.ts = _nwcmStatusData.docTs;

        for(var i=0;i<_nwcmStatusData.Points.length;i++){
            let _pointToken:NWCMPointData = _nwcmStatusData.Points[i];
            _json.kpistatus.push({"kpiid":_pointToken.KPIId,"kpistatus":_pointToken.KPIStatus,"kpi_image_ref": _pointToken.KPIImageRef});
        }
        return _json;
    }
    getGembaCardJsonFromObj(dt:Date,pt:string):any{    
        let _json:any = {};
        _json.month = new Date(dt).getMonth()+1;
        _json.year = new Date(dt).getFullYear();
        _json.product_type = pt;
      return _json;
    }
    getInprogressQualityIssueJsonFromObj(_mtrlShrt:InprocessQualityIssues):any{
        let _json:any = {};
        _json.id = _mtrlShrt.id;
        _json.selmonth = _mtrlShrt.monthDateNum;
        _json.days = [];
        _json.ts = _mtrlShrt.docTs;

        for(var i=0;i<_mtrlShrt.dayTokens.length;i++){
            let _dayToken:IQIDayToken = _mtrlShrt.dayTokens[i];
            let _dayJson:any = {};
            _dayJson.seldate = GenService.getDateFormatStr(_dayToken.selDate,'YYYYMMDD');
            _dayJson.rows = [];
            for(var j=0;j<_dayToken.dateTokens.length;j++){
                _dayJson.rows.push({"rowId":_dayToken.dateTokens[j].rowId,"productName":_dayToken.dateTokens[j].productName,"productType":_dayToken.dateTokens[j].productType,
                "productDesc":_dayToken.dateTokens[j].productDesc,
                "quantity":_dayToken.dateTokens[j].quantity,"issueRelated":_dayToken.dateTokens[j].issueRelated,
                "supplierName":_dayToken.dateTokens[j].supplierName,"ncrCapturing":_dayToken.dateTokens[j].ncrCapturing,
                "issueCapturing":_dayToken.dateTokens[j].issueCapturing,"defectCategory":_dayToken.dateTokens[j].defectCategory,
                "defectSubCategory1":_dayToken.dateTokens[j].defectSubCategory1,"defectSubCategory2":_dayToken.dateTokens[j].defectSubCategory2,
                "defectSubCategory3":_dayToken.dateTokens[j].defectSubCategory3,"rootCause":_dayToken.dateTokens[j].rootCause,
                "dispositionDecision":_dayToken.dateTokens[j].dispositionDecision,"actionDecided":_dayToken.dateTokens[j].actionDecided,
                "preventiveAction":_dayToken.dateTokens[j].preventiveAction,"respPrsn":_dayToken.dateTokens[j].respPrsn
                ,"targetDateNum":_dayToken.dateTokens[j].targetDateNum,"status":_dayToken.dateTokens[j].status,
                 "shortageNotes":_dayToken.dateTokens[j].shortageNotes,"createdDate":_dayToken.dateTokens[j].creationDate,
                "severityValue":_dayToken.dateTokens[j].severityValue});
            }
            _json.days.push(_dayJson);
        }
        return _json;
    }
    getManPowerAllocationJsonFromObj(_mtrlShrt:TaskAllocation):any{
        let _json:any = {};
        _json.id = _mtrlShrt.id;
        _json.selmonth = _mtrlShrt.monthDateNum;
        _json.days = [];
        _json.ts = _mtrlShrt.docTs;
        
        for(var i=0;i<_mtrlShrt.dayTokens.length;i++){
            let _dayToken:TaskDayToken = _mtrlShrt.dayTokens[i];
            let _dayJson:any = {};
            _dayJson.seldate = GenService.getDateFormatStr(_dayToken.selDate,'YYYYMMDD');
            _dayJson.rows = [];
            for(var j=0;j<_dayToken.dateTokens.length;j++){
                let _taskJson=[];
                for(var k=0;k<_dayToken.dateTokens[j].users.length;k++){
                    _taskJson.push({"email":_dayToken.dateTokens[j].users[k].email,"displayName":_dayToken.dateTokens[j].users[k].displayName});
                }
                _dayJson.rows.push({"workCategoryId":_dayToken.dateTokens[j].workCategoryId,"workCategoryName":_dayToken.dateTokens[j].workCategoryName,"taskId":_dayToken.dateTokens[j].taskId,"taskName":_dayToken.dateTokens[j].taskName,"users":_taskJson,"orderno":(i+1),"quantity":_dayToken.dateTokens[j].quantity});
            }
            _json.days.push(_dayJson);
        }
        // _json.workList = [];
        //  for(var i=0;i<_mtrlShrt.taskLinked.length;i++){
        //       let _taskJson:any = [];
        //      for(var j=0;j<_mtrlShrt.taskLinked[i].users.length;j++){
        //          let temp = _mtrlShrt.taskLinked[i].users[j];
        //         _taskJson.push({"email":temp.email,"displayName":temp.displayName});
        //      }
        //      _json.workList.push({"workCategoryId":_mtrlShrt.taskLinked[i].workCategoryId,"workCategoryName":_mtrlShrt.taskLinked[i].workCategoryName,"taskId":_mtrlShrt.taskLinked[i].taskId,"taskName":_mtrlShrt.taskLinked[i].taskName,"users":_taskJson,"orderno":(i+1)})
        //  }
        return _json;
    }
    getFgMonthlyDataJsonFromObj(_fgDaily:FinishedGoodsDaily):any{
        let _json:any = {};
        _json._seldate = _fgDaily.dateNum;
        _json._selmonth = _fgDaily.monthNum;
        _json._domestic_breaker = _fgDaily.domesticBreaker;
        _json._export_breaker = _fgDaily.exportBreaker;
        _json._magnetic_actuator = _fgDaily.magneticActuator;

        return _json
    }

    saveBrainStormProblem(_problem:ProblemDetails,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getProblemDetailsJsonFromObj(_problem); 
        let saveresp = this.http.post(DataService.saveBSProblem,{"prob":jsonObj,"sendmail":(_sendMail ? "1":"0") })
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    savePlan(_dlyProdHigh: Plan): Observable<GenResponse> {
        let jsonObj: any = this.getPlanJsonFromObj(_dlyProdHigh);
        let saveresp = this.http.post(DataService.savePlanApi, { "prod": jsonObj })
            .map((res: Response) => {
                let respJson = res.json();
                this.checkAuthentication(respJson);
                return this.getDataSavedResponse(respJson);
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    saveDailyProdHighlight(_dlyProdHigh:DailyProdHighlights,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getDailyProdHighJsonFromObj(_dlyProdHigh); 
        let saveresp = this.http.post(DataService.saveDailyProdHighApi,{"prod":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }

    saveMaterialShortage(_datatable:MaterialShortage,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getMaterialShortageJsonFromObj(_datatable); 
        let saveresp = this.http.post(DataService.saveMaterialShortageApi,{"prod":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);

                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }

    saveDailyDeliveryPlan(_datatable:DailyDeliveryPlan,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getDailyDeliveryPlanJsonFromObj(_datatable); 
        console.log('save',jsonObj);
        let saveresp = this.http.post(DataService.saveDailyDeliveryPlanApi,{"prod":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }

    saveCustmrInspPlan(_datatable:CustomerInspectionPlan,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getCustomerInspectionPlanJsonFromObj(_datatable); 
        let saveresp = this.http.post(DataService.saveCustmrInspecPlanApi,{"prod":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    savePoleStockRevw(_datatable:PoleStockReview,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getPoleStockReviewJsonFromObj(_datatable); 
        let saveresp = this.http.post(DataService.savePoleStockApi,{"prod":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    // saveSeverity(_data:any):Observable<string>{
     
    //     let saveresp = this.http.post(DataService.saveSeverity,{"prod":_data})
    //             .map((res:Response) =>{ 
    //                 let respJson = res.json();
    //                 this.checkAuthentication(respJson);
    //                 if(respJson.status=="OK"){
    //                     return respJson.docid;
    //                 }
    //                 else 
    //                     return "";
    //             })
    //             .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
    //     return saveresp;
             
    // }
    saveInprocessQualityIssues(_datatable:InprocessQualityIssues,_productLineID: string,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getInprogressQualityIssueJsonFromObj(_datatable); 
        let saveresp = this.http.post(DataService.saveInprocessQualityIssuesApi, { "prod": jsonObj, "plineid": _productLineID, "sendmail": (_sendMail ? "1" : "0") })
                .map((res:Response) =>{ 
                    console.log("resp?",saveresp)
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    saveManPowerAllocation(_datatable:TaskAllocation,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getManPowerAllocationJsonFromObj(_datatable); 
        let saveresp = this.http.post(DataService.saveManPowerApi,{"prod":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    saveGreenStickerPlan(_gspObj:GreenStickerPlan,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getGreenStickerPlanJsonFromObj(_gspObj);
        let saveresp = this.http.post(DataService.saveGreenStickerPlanApi,{"prod":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    saveCCRPStatusMntring(_datatable:CCRPStatusMonitoring,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getCCRPStatusMtrJsonFromObj(_datatable); 
        console.log('ccrp',jsonObj.data);

        let saveresp = this.http.post(DataService.saveCCRPStatusApi,{"prod":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    saveProdStatusMonitoring(_datatable:ProductionStatusMonitoring,_sendMail:boolean):Observable<GenResponse>{
        let jsonObj:any = this.getProdStatusMtrJsonFromObj(_datatable); 
        let saveresp = this.http.post(DataService.saveProdStatusApi,{"prod":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    sendGembaMoM(_selMonth:Date):Observable<string>{
        let _subscrb = this.http.post(DataService.sendGembaMoM,{"selmonth":_selMonth})
                 .map((res:Response) =>{ 
                    let respJson = res.json();
                    if(respJson.status=="OK"){
                        return respJson;
                    }
                    else 
                        return "";
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return _subscrb;
            
    }
    saveNWCMTreeInfo(_nwcmStatuMonthData:NWCMStatusMonthData):Observable<GenResponse>{
        let jsonObj:any = this.getNWCMStatusJsonFromObj(_nwcmStatuMonthData); 
        let _sendMail:boolean = false;
        let saveresp = this.http.post(DataService.saveNWCMTreeStatusApi,{"nwcm":jsonObj,"sendmail":(_sendMail ? "1":"0")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    saveGembaCardsData(data:any):Observable<GenResponse>{
      //  let jsonObj:any = this.getProdStatusMtrJsonFromObj(_datatable); 
        let saveresp = this.http.post(DataService.saveGembaCardApi,{"prod":data})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    return this.getDataSavedResponse(respJson);
                })
                .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    getGembaCardsData(dt:Date,pt:string):Observable<string>{
        let jsonObj:any = this.getGembaCardJsonFromObj(dt,pt); 
        let saveresp = this.http.post(DataService.getGembaCardApi,{"prod":jsonObj})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
            if(respJson.status=="OK"){
                return respJson;
            }
            else 
                return "";
        })
        .catch((error:any) => Observable.throw(error.json().error || 'Server error'))
        return saveresp;
    }
    public getKpiImage(_tempImageId: string): Observable<boolean> {
        let jsonObj: any = {};
        jsonObj._imgId = _tempImageId;
        let list = this.http.post(DataService.getKpiImage, { 'getObj': jsonObj })
            .map((res: Response) => {
                let respJson = res.json();
                this.checkAuthentication(respJson);
                if (respJson.status == "OK") {
                    this._e_KpiImage = new e_KpiImage(respJson.data.imgId, respJson.data.imgName, respJson.data.imgType, respJson.data.imgBase64Data);
                    return true;
                }
                else
                    return false;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return list;
    }
    saveFgMonthlyData(_fgDailyObj:FinishedGoodsDaily): Observable<boolean>{
        let jsonObj:any = this.getFgMonthlyDataJsonFromObj(_fgDailyObj); 

        let list = this.http.post(DataService.saveFinishedGoodsMonthly, { 'saveObj': jsonObj })
            .map((res: Response) => {
                let respJson = res.json();
                this.checkAuthentication(respJson);
                if (respJson.status == "OK") {
                    return true;
                }
                else
                    return false;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return list;
    }
    public loadStockInfoMonthly(_selMonth:Date):Observable<Array<FinishedGoodsDaily>>{
        let _subscrb = this.http.post(DataService.getFinishedGoodsMonthly,{"selmonth":GenService.getDateFormatStr(_selMonth,"YYYYMM")})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    // console.log(respJson);
                    if(respJson.status=="OK"){
                        let json = respJson.data;
                        let _tmpfgDailyTokenArr:Array<FinishedGoodsDaily> = [];

                        for(var i=0;i<json.length;i++){
                            let _tmpfgDailyToken:FinishedGoodsDaily = new FinishedGoodsDaily(json[i].seldate,json[i].domestic_breaker,json[i].export_breaker,json[i].magnetic_actuator,json[i].total_fg,json[i].total_rev,[]);
                            let _inRows = json[i].rows;

                            for(var j=0;j<_inRows.length;j++){
                                _tmpfgDailyToken.addFGToken(new FinishedGoodsToken(_inRows[j].ohe,_inRows[j].region,_inRows[j].customer,
                                    _inRows[j].so,_inRows[j].so_line_item,_inRows[j].cb,_inRows[j].qty,_inRows[j].actual_gs_date,
                                    _inRows[j].age,_inRows[j].ps_nos,_inRows[j].revenue_minr,_inRows[j].sale_order_incoterm,
                                    _inRows[j].structure,_inRows[j].ct_structure,_inRows[j].tc,_inRows[j].special_points,
                                    _inRows[j].target_dispatch_date,_inRows[j].actual_dispatch_date,_inRows[j].remarks));
                            }
                            _tmpfgDailyTokenArr.push(_tmpfgDailyToken);
                        }
                        _tmpfgDailyTokenArr.sort((_a:FinishedGoodsDaily,_b:FinishedGoodsDaily) => {
                            return _a.dateNum - _b.dateNum;
                        });
                        return _tmpfgDailyTokenArr;
                        
                    }
                    else if(respJson.status=="NONE"){
                        return [];
                    }
                    else 
                        return null; 
                })
                .catch((error:any) => Observable.throw(error || 'Server error'))
        return _subscrb;
    }

    public downloadFile(_startDate:Date,_endDate:Date,_formPage,_productLine) {
            let url:string
           switch(_formPage){
                case "Inprocess":
                    url  = DataService.downloadFile + this.getInprocessQualityUrlQueryByDate(_startDate,_endDate,_productLine);
                    
                   break;
                case "CCRP":
                    url  = DataService.downloadFile + this.getInprocessCCRPQueryByDate(_startDate,_endDate);
                    //console.log("ccrp url",url)
                   break;
                case "DailyDelivery":
                    url = DataService.downloadFile + this.getDailyDeliveryUrlQueryByDate(_startDate,_endDate);
                   //console.log("delivery url",url)
                    break;
                }
        window.open(url);
    }

    public loadInprocessQualityImportData():Observable<Array<itsQIssue>>{
        let _subscrb = this.http.post(DataService.getInprocessQualityImportDataApi,{})
        .map((res:Response) =>{ 
            let respJson = res.json();
            this.checkAuthentication(respJson);
             console.log(respJson);
            if(respJson.status == "OK"){
                let _tmpQIssues:Array<itsQIssue> = [];
                for(var i=0; i<respJson.data.length; i++){
                    var _token = respJson.data[i].qIssue;
                    if(_token.plantId && _token.lineId && _token.productId && _token.issueId && _token.stationId
                        &&  _token.serialNo && _token.issueCaptureTime && _token.issueDescription){
                            _tmpQIssues.push(new itsQIssue(_token.lineId,_token.productId,_token.issueId,_token.stationId,
                                _token.serialNo,_token.issueCaptureTime,_token.issueDescription,
                                respJson.data[i]._ts, respJson.data[i].id));
                        }
                        
                }
                console.log("issues are ::" , _tmpQIssues)
                return _tmpQIssues;
                
            }
            
            return null;
        });
return _subscrb;
       
    }

    public discardExportInprocessRecords(_records:any):Observable<boolean>{
        let _subscrb = this.http.post(DataService.discardInprocessExportRecordsApi,{"recs":_records})
                .map((res:Response) =>{ 
                    let respJson = res.json();
                    this.checkAuthentication(respJson);
                    // console.log(respJson);
                    if(respJson.status == "OK"){
                        return true
                    }
                    return false;
                });
        return _subscrb;
    }
 
    getProductName(_productId:string):string{
       if(this._productList){
            let _tmpproduct = this._productList.find((_prod:ProductsList) => {
                return _prod.productId == _productId;
            });
            if(_tmpproduct) return _tmpproduct.productName;
            return _productId ;
       }
     //  return _productId
        
    }
    getProductMAName(_productId:string):string{
        let _tmpproduct = this._productListMA.find((_prod:Product) => {
            return _prod.productId == _productId;
        });
        if(_tmpproduct) return _tmpproduct.productName;
        return _productId;
    }
    getProductType(_productId:string):string{
        let _tmpproduct = this._productType.find((_prod:Product) => {
            return _prod.productId == _productId;
        });
        if(_tmpproduct) return _tmpproduct.productName;
        return _productId;
    }
    getProductTypeBasedOnProductId(_productId:string):string{
        let _tmpproduct = this._productList.find((_prod:ProductsList) => {
            return _prod.productId == _productId;
        });
         if(_tmpproduct) return _tmpproduct.productType
        //     let _tmpproducttype = this._productType.find((_prodtype:Product) => {
        //         return _prodtype.productId == _tmpproduct.productType;
        //     }); 
        //     if(_tmpproducttype) return ''
        // } 
        return "";
    }
    getMainProduct(_productId:string):string{
        let _tmpproduct = this._mainProduct.find((_prod:Product) => {
            return _prod.productId == _productId;
        });
        if(_tmpproduct) return _tmpproduct.productName;
        return _productId;
    }
    getInspectionDoneBy(_inspId:string):string{
        let _tmpinsp = this._inspectionDoneBy.find((_insp:InspectionDoneBy) => {
            return _insp.inspectionId == _inspId;
        });
        if(_tmpinsp) return _tmpinsp.inspName;
        return _inspId;
    }
    getCustomerName(_custId:string):string{
        if(this._customerList){            
            let _tmpcustomer = this._customerList.find((_cust:Customer) => {
                return _cust.custId == _custId;
            });
            if(_tmpcustomer) return _tmpcustomer.custName;
            return _custId ;
        }
    }
    getSubProduct(mainId:string,tyId:string):string{
        let _tmpType = this._subProduct.find((ty:subProduct) => {
            return ty.subProductId == tyId && ty.productId == mainId
        })
        if(_tmpType) return _tmpType.subProductName;
        return tyId;
    }
    getIssueRelated(id:string):string{
        let _tmp = this._issueRelatedTo.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getNCRCapturing(id:string):string{
        let _tmp = this._ncrCapturing.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getIssueCapturing(id:string):string{
        let _tmp = this._issueCapturing.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getStatus(id:string):string{
        let _tmp = this._status.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getDefectCategory(id:string){
        let _tmp = this._defectCategory.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getDefectSubCategory1(id:string):string{
        let _tmp = this._defectSubCategory1.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getDefectSubCategory2(id:string):string{
        let _tmp = this._defectSubCategory2.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getDefectSubCategory3(id:string):string{
        let _tmp = this._defectSubCategory3.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getSupplierName(id:string):string{
        let _tmp = this._supplierName.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getDepositionDecision(id:string):string{
        let _tmp = this._depositionDecision.find((_cust:Def) => {
            return _cust.defId == id;
        });
        if(_tmp) return _tmp.defName;
        return "-" ;
    }
    getShortage(id:string):string{
        let _tmpType = this._shortage.find((ty:Type) => {
            return ty.typeId == id
        })
        if(_tmpType) return _tmpType.typeName;
        return id;
    }
    getRecordStatus(id:string):string{
        let _tmpType = this._formStatus.find((ty:Type) => {
            return ty.typeId == id
        })
        if(_tmpType) return _tmpType.typeName;
        return id;        
    }
    getShrtgeFormStatus(id:string):string{
        let _tmpType = this._shrtgeFormStatus.find((ty:Type) => {
            return ty.typeId == id
        })
        if(_tmpType) return _tmpType.typeName;
        return id;        
    }
    getTypeReady(id:string):string{
        let _tmpType = this._typeReady.find((ty:Type) => {
            return ty.typeId == id
        })
        if(_tmpType) return _tmpType.typeName;
        return id;
    }
    getCCRPStatus(id:string):string{
        let _tmpType = this._ccrpStatus.find((ty:Type) => {
            return ty.typeId == id
        })
        if(_tmpType) return _tmpType.typeName;
        return id;
    }
    getDispStatus(id:string):string{
        let _tmpType = this._dispStatus.find((ty:Type) => {
            return ty.typeId == id
        })
        if(_tmpType) return _tmpType.typeName;
        return id;
    }
    getCCRPReason(id:string):string{
        let _tmpType = this._ccrpReason.find((ty:Type) => {
            return ty.typeId == id
        })
        if(_tmpType) return _tmpType.typeName;
        return id;
    }
    getTypeAvailable(id:string):string{
        let _tmpType = this._typeAvailable.find((ty:Type) => {
            return ty.typeId == id
        })
        if(_tmpType) return _tmpType.typeName;
        return id;
    }
    getTypeStructure(id:string):string{
        let _tmpType = this._typeStructure.find((ty:Type) => {
            return ty.typeId == id
        })
        if(_tmpType) return _tmpType.typeName;
        return id;
    }
    getPoleDescPartNo(pid:string,id:string):string{
        let _tmpType = this._polePartList.find((ty:PolePart) => {
            return ty.poleId == id && ty.productId == pid
        })
        if(_tmpType) return _tmpType.partDescription;
        return id;        
    }
    getResponsiblePrsn(_prsnId:string):string{
      if(this._respPersonList){
        let _tmpRspn = this._respPersonList.find((_prsn:RespPerson) =>{
            return _prsn.respId == _prsnId;
        });
        if(_tmpRspn) return _tmpRspn.respName;
        return "-" 
      }
      else{
        return "-"
      }
    }
    getProductsProductType(id:string):string{
        let _tmpPrd = this._productList.find((_pdct:ProductsList) =>{
            return _pdct.productId == id;
        });
        if(_tmpPrd) return _tmpPrd.productType;
        return "-" 
    }
    mAccess(_modId:string){
        return true;
        // for(var i=0;i<this._accessLevels.length;i++){
        //     if(this._accessLevels[i].Id == _modId){
        //         return true;
        //     }
        // }
        // return false;
    }
    hasEditAccess(_modId:string,_pid:string){
        if(this._accessLevel == 'admin' || this._accessLevel == 'edit')
            return true;
        else
            return false;

        // for(var i=0;i<this._accessLevels.length;i++){
        //     if(this._accessLevels[i].Id == _modId){
        //         return this._accessLevels[i].hasWriteAccess(_pid);
        //     }
        // }
        // return false;
    }
    hasReadAccess(_modId:string,_pid:string){
        return true;
        // for(var i=0;i<this._accessLevels.length;i++){
        //     if(this._accessLevels[i].Id == _modId){
        //         return this._accessLevels[i].hasReadAccess(_pid);
        //     }
        // }
        // return false;
    }
    // getAccessGrantLevel(_modId:string):Observable<boolean>{

    // }
   
    
    getManPowerAllocation():ManPowerAllocation{
        return this._manPowerAllocation;
    }
    
    getInprocessQualityUrlQueryByDate(startDate:Date,endDate:Date,prodLine:string){
         let _urlParam:string = "";
        _urlParam = "?startYearMonth="+ GenService.getDateFormatStr(startDate, "YYYYMM")
                +"&endYearMonth=" + GenService.getDateFormatStr(endDate, "YYYYMM")
                +"&startDate=" + GenService.getDateFormatStr(startDate, "YYYYMMDD")
                +"&endDate=" + GenService.getDateFormatStr(endDate, "YYYYMMDD")
                +"&fromPage= Inprocess";
                +"&productLine=" +prodLine;
      return _urlParam;
    }
    getInprocessCCRPQueryByDate(_startDate:Date,_endDate:Date){
         let _urlParam:string = "";
        _urlParam = "?startDate="+ GenService.getDateFormatStr(_startDate, "YYYYMMDD")
                    +"&endDate=" + GenService.getDateFormatStr(_endDate, "YYYYMMDD")
                    +"&fromPage= CCRP";;
      return _urlParam;
    }
    getDailyDeliveryUrlQueryByDate(startDate:Date,endDate:Date){
        let _urlParam:string = "";
       _urlParam = "?&startDate=" + GenService.getDateFormatStr(startDate, "YYYYMMDD")
               +"&endDate=" + GenService.getDateFormatStr(endDate, "YYYYMMDD")
               +"&fromPage= DailyDelivery";;
     return _urlParam;
    }
    getDataSavedResponse(respJson):GenResponse{
        if(respJson.status=="OK"){
            return new GenResponse(respJson.status, DataService.saveSuccessMsg, DataService.successCode,respJson.docid);
        }
        else {
            if (respJson.error && respJson.error == DataService.staleDataCode) {
                return new GenResponse(respJson.status, DataService.staleDateErrorMsg, respJson.error,null);
            }
            return new GenResponse(respJson.status, DataService.saveErrorMsg, DataService.failCode,null);
        }
    }
    //publis functions end
}

